//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthClient } from '../app/services/authService';
import { getAccessToken } from 'app/utils/authUtilities';
export class RequestApiClientBase {
    constructor() { };

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        if (options.headers) {
            let token = getAccessToken();
            if(token === null) {
                token = await new AuthClient().getToken();
            }
            var headers = options.headers as { [index: string]: string };
            headers['Authorization'] = `Bearer ${token}`;
        }
        return Promise.resolve(options);
    }

    protected async transformResult(
        url: string,
        response: Response,
        processResponse: (_response: Response) => Promise<any>
    ): Promise<any> {
        try {
            return await processResponse(response);
        } catch (error: any) {
            if(response.ok) {
                return;
            }

            throw new ApiError(
                response.status,
                response.statusText,
                error?.result ?? error
            );
        }
    }
}

export class RequestApiClient extends RequestApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all the Surface devices
     */
    lookUp_GetDeviceList(): Promise<DeviceCategory[]> {
        let url_ = this.baseUrl + "/request/LookUp/DeviceList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookUp_GetDeviceList(_response));
        });
    }

    protected processLookUp_GetDeviceList(response: Response): Promise<DeviceCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceCategory[]>(null as any);
    }

    /**
     * Gets all the Industries
     */
    lookUp_GetIndustries(): Promise<IndustryMaster[]> {
        let url_ = this.baseUrl + "/request/LookUp/Industries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookUp_GetIndustries(_response));
        });
    }

    protected processLookUp_GetIndustries(response: Response): Promise<IndustryMaster[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IndustryMaster.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndustryMaster[]>(null as any);
    }

    /**
     * Gets the reason for reassignments
     */
    lookUp_ReasonForReassignment(): Promise<EnumLookUp> {
        let url_ = this.baseUrl + "/request/LookUp/ReasonForReassignment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookUp_ReasonForReassignment(_response));
        });
    }

    protected processLookUp_ReasonForReassignment(response: Response): Promise<EnumLookUp> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnumLookUp.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumLookUp>(null as any);
    }

    /**
     * Gets the list of Teams
     */
    lookUp_Teams(): Promise<EnumLookUp[]> {
        let url_ = this.baseUrl + "/request/LookUp/Teams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookUp_Teams(_response));
        });
    }

    protected processLookUp_Teams(response: Response): Promise<EnumLookUp[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnumLookUp.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumLookUp[]>(null as any);
    }

    /**
     * Gets the list of all Request Types
     */
    lookUp_RequestTypes(): Promise<EnumLookUp[]> {
        let url_ = this.baseUrl + "/request/LookUp/RequestTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookUp_RequestTypes(_response));
        });
    }

    protected processLookUp_RequestTypes(response: Response): Promise<EnumLookUp[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnumLookUp.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumLookUp[]>(null as any);
    }

    /**
     * Mock endpoint for MSX Data
     */
    lookUp_Msx(): Promise<MsxStaticData[]> {
        let url_ = this.baseUrl + "/request/LookUp/Msx";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookUp_Msx(_response));
        });
    }

    protected processLookUp_Msx(response: Response): Promise<MsxStaticData[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MsxStaticData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MsxStaticData[]>(null as any);
    }

    /**
     * Get all the request type details
     */
    lookUp_RequestTypeDetails(): Promise<RequestTypeDetailsDto[]> {
        let url_ = this.baseUrl + "/request/LookUp/RequestTypeDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookUp_RequestTypeDetails(_response));
        });
    }

    protected processLookUp_RequestTypeDetails(response: Response): Promise<RequestTypeDetailsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequestTypeDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestTypeDetailsDto[]>(null as any);
    }

    /**
     * Gets all the Countries
     */
    lookUp_GetCountries(): Promise<CountryMaster[]> {
        let url_ = this.baseUrl + "/request/LookUp/Countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookUp_GetCountries(_response));
        });
    }

    protected processLookUp_GetCountries(response: Response): Promise<CountryMaster[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryMaster.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryMaster[]>(null as any);
    }

    /**
     * Gets all product area categories with subcategories and products
     */
    lookUp_GetProductAreaCategories(): Promise<ProductAreaCategory[]> {
        let url_ = this.baseUrl + "/request/LookUp/ProductAreaCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookUp_GetProductAreaCategories(_response));
        });
    }

    protected processLookUp_GetProductAreaCategories(response: Response): Promise<ProductAreaCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductAreaCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductAreaCategory[]>(null as any);
    }

    reassign_Reassign(reassignEvent: ReassignRequestDto): Promise<void> {
        let url_ = this.baseUrl + "/request/Reassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reassignEvent);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReassign_Reassign(_response));
        });
    }

    protected processReassign_Reassign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Identify the request type and sub type using ML Model
     * @param routeRequest The Request object
     */
    route_IdentifyDomain(routeRequest: RouteRequest): Promise<RouteResponse> {
        let url_ = this.baseUrl + "/request/Route";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(routeRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoute_IdentifyDomain(_response));
        });
    }

    protected processRoute_IdentifyDomain(response: Response): Promise<RouteResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RouteResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RouteResponse>(null as any);
    }

    /**
     * Create Feedback
     */
    adminFeedback_CreateFeedback(feedbackDto: CreateFeedbackDto): Promise<void> {
        let url_ = this.baseUrl + "/request/AdminFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedbackDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdminFeedback_CreateFeedback(_response));
        });
    }

    protected processAdminFeedback_CreateFeedback(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get Feedback
     * @param isnewFeedbackOnly (optional) For only new feedback set true
     * @return Feedback based on the
     */
    adminFeedback_Feedback(isnewFeedbackOnly: boolean | undefined): Promise<FeedbackResponseDto[]> {
        let url_ = this.baseUrl + "/request/AdminFeedback/Feedback?";
        if (isnewFeedbackOnly === null)
            throw new Error("The parameter 'isnewFeedbackOnly' cannot be null.");
        else if (isnewFeedbackOnly !== undefined)
            url_ += "isnewFeedbackOnly=" + encodeURIComponent("" + isnewFeedbackOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdminFeedback_Feedback(_response));
        });
    }

    protected processAdminFeedback_Feedback(response: Response): Promise<FeedbackResponseDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeedbackResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeedbackResponseDto[]>(null as any);
    }

    /**
     * Send the response to the feedback
     * @param adminResponse (optional) 
     */
    adminFeedback_Respond(id: string, adminResponse: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/request/AdminFeedback/Feedback/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (adminResponse !== undefined && adminResponse !== null)
            url_ += "adminResponse=" + encodeURIComponent("" + adminResponse) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdminFeedback_Respond(_response));
        });
    }

    protected processAdminFeedback_Respond(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get Comments with pagination
     * @param commentText (optional) 
     * @param correlationId (optional) 
     * @param entityType (optional) 
     * @param id (optional) 
     * @param parentCommentId (optional) 
     * @param isActive (optional) 
     * @param isInternal (optional) 
     * @param dateRange_From (optional) 
     * @param dateRange_To (optional) 
     * @param sortProperty (optional) 
     * @param sortDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    comment_GetCommentList(commentText: string | null | undefined, correlationId: string | null | undefined, entityType: EntityType | null | undefined, id: string | null | undefined, parentCommentId: string | null | undefined, isActive: boolean | null | undefined, isInternal: boolean | null | undefined, dateRange_From: Date | undefined, dateRange_To: Date | undefined, sortProperty: string | null | undefined, sortDirection: ListSortDirection | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfCommentResponseDto> {
        let url_ = this.baseUrl + "/request/Comment/list?";
        if (commentText !== undefined && commentText !== null)
            url_ += "CommentText=" + encodeURIComponent("" + commentText) + "&";
        if (correlationId !== undefined && correlationId !== null)
            url_ += "CorrelationId=" + encodeURIComponent("" + correlationId) + "&";
        if (entityType !== undefined && entityType !== null)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (parentCommentId !== undefined && parentCommentId !== null)
            url_ += "ParentCommentId=" + encodeURIComponent("" + parentCommentId) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isInternal !== undefined && isInternal !== null)
            url_ += "IsInternal=" + encodeURIComponent("" + isInternal) + "&";
        if (dateRange_From === null)
            throw new Error("The parameter 'dateRange_From' cannot be null.");
        else if (dateRange_From !== undefined)
            url_ += "DateRange.From=" + encodeURIComponent(dateRange_From ? "" + dateRange_From.toISOString() : "") + "&";
        if (dateRange_To === null)
            throw new Error("The parameter 'dateRange_To' cannot be null.");
        else if (dateRange_To !== undefined)
            url_ += "DateRange.To=" + encodeURIComponent(dateRange_To ? "" + dateRange_To.toISOString() : "") + "&";
        if (sortProperty !== undefined && sortProperty !== null)
            url_ += "SortProperty=" + encodeURIComponent("" + sortProperty) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processComment_GetCommentList(_response));
        });
    }

    protected processComment_GetCommentList(response: Response): Promise<PaginatedListOfCommentResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCommentResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCommentResponseDto>(null as any);
    }

    /**
     * Create Comment
     * @param commentDto Comment dto
     * @return CommentId on success (GUID)
     */
    comment_CreateComment(commentDto: CreateCommentDto): Promise<string> {
        let url_ = this.baseUrl + "/request/Comment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processComment_CreateComment(_response));
        });
    }

    protected processComment_CreateComment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Remove Comment
     * @param id (optional) Comment Id
     * @param correlationId (optional) UnifiedTracking Id
     * @param entityType (optional) Entity Type
     * @return CommentId on success (GUID)
     */
    comment_RemoveComment(id: string | undefined, correlationId: string | null | undefined, entityType: EntityType | undefined): Promise<string> {
        let url_ = this.baseUrl + "/request/Comment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (correlationId !== undefined && correlationId !== null)
            url_ += "correlationId=" + encodeURIComponent("" + correlationId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processComment_RemoveComment(_response));
        });
    }

    protected processComment_RemoveComment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Create Comment
     * @param commentDto Comment dto
     */
    comment_UpdateComment(commentDto: CommentDto): Promise<boolean> {
        let url_ = this.baseUrl + "/request/Comment/CommentUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processComment_UpdateComment(_response));
        });
    }

    protected processComment_UpdateComment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Adds an emote to a comment
     * @param addEmoteDto Dto for adding emotes
     */
    comment_AddEmote(addEmoteDto: AddEmoteDto): Promise<Unit> {
        let url_ = this.baseUrl + "/request/Comment/Emote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addEmoteDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processComment_AddEmote(_response));
        });
    }

    protected processComment_AddEmote(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }

    /**
     * Gets the current runtime feature flags. Defaults to all-off when a flag is unset.
     */
    features_GetFeatures(): Promise<FeatureFlagsDto> {
        let url_ = this.baseUrl + "/request/Features";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFeatures_GetFeatures(_response));
        });
    }

    protected processFeatures_GetFeatures(response: Response): Promise<FeatureFlagsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureFlagsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureFlagsDto>(null as any);
    }

    file_DownloadAttachment(fileName: string): Promise<BlobAttachmentDto> {
        let url_ = this.baseUrl + "/request/File/DownloadAttachment/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFile_DownloadAttachment(_response));
        });
    }

    protected processFile_DownloadAttachment(response: Response): Promise<BlobAttachmentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlobAttachmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlobAttachmentDto>(null as any);
    }

    file_GenerateFileSasToken(containerName: string, fileName: string): Promise<string> {
        let url_ = this.baseUrl + "/request/File/GenerateFileSasToken/{containerName}/{fileName}";
        if (containerName === undefined || containerName === null)
            throw new Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFile_GenerateFileSasToken(_response));
        });
    }

    protected processFile_GenerateFileSasToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    file_GenerateContainerSasToken(containerName: string): Promise<string> {
        let url_ = this.baseUrl + "/request/File/GenerateContainerSasToken/{containerName}";
        if (containerName === undefined || containerName === null)
            throw new Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFile_GenerateContainerSasToken(_response));
        });
    }

    protected processFile_GenerateContainerSasToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    file_UploadFile(file: FileParameter | null | undefined): Promise<BlobAttachmentDto> {
        let url_ = this.baseUrl + "/request/File/UploadAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFile_UploadFile(_response));
        });
    }

    protected processFile_UploadFile(response: Response): Promise<BlobAttachmentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlobAttachmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlobAttachmentDto>(null as any);
    }

    home_Index(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/request";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHome_Index(_response));
        });
    }

    protected processHome_Index(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    request_BeginCustomerFamilyOperation(dto: CustomerFamilyOperationRequestDto): Promise<CustomerFamilyOperationDto> {
        let url_ = this.baseUrl + "/Request/CustomerFamilyOperation/Begin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_BeginCustomerFamilyOperation(_response));
        });
    }

    protected processRequest_BeginCustomerFamilyOperation(response: Response): Promise<CustomerFamilyOperationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerFamilyOperationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerFamilyOperationDto>(null as any);
    }

    request_PrepareCustomerFamilyParent(submissionId: string): Promise<CustomerFamilyOperationDto> {
        let url_ = this.baseUrl + "/Request/CustomerFamilyOperation/{submissionId}/PrepareParent";
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_PrepareCustomerFamilyParent(_response));
        });
    }

    protected processRequest_PrepareCustomerFamilyParent(response: Response): Promise<CustomerFamilyOperationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerFamilyOperationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerFamilyOperationDto>(null as any);
    }

    request_CompleteCustomerFamilyOperation(dto: CompleteCustomerFamilyOperationDto): Promise<CustomerFamilyOperationDto> {
        let url_ = this.baseUrl + "/Request/CustomerFamilyOperation/Complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_CompleteCustomerFamilyOperation(_response));
        });
    }

    protected processRequest_CompleteCustomerFamilyOperation(response: Response): Promise<CustomerFamilyOperationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerFamilyOperationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerFamilyOperationDto>(null as any);
    }

    request_ReconcileCustomerImpactEdits(requestId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/Request/{requestId}/CustomerImpactEdit/Reconcile";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_ReconcileCustomerImpactEdits(_response));
        });
    }

    protected processRequest_ReconcileCustomerImpactEdits(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get the Request Details by Unified ID
     * @param requestId Request Id for querying
     * @return The Request Object
     */
    request_GetRequestDetails(requestId: string): Promise<RequestDto> {
        let url_ = this.baseUrl + "/Request/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_GetRequestDetails(_response));
        });
    }

    protected processRequest_GetRequestDetails(response: Response): Promise<RequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestDto>(null as any);
    }

    /**
     * Create a Request
     * @return Returns the newly created Irt id
     */
    request_CreateRequest(requestObject: RequestDto): Promise<string> {
        let url_ = this.baseUrl + "/Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestObject);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_CreateRequest(_response));
        });
    }

    protected processRequest_CreateRequest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    request_UpdateRequest(updateRequestDto: UpdateRequestDto): Promise<string> {
        let url_ = this.baseUrl + "/Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRequestDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_UpdateRequest(_response));
        });
    }

    protected processRequest_UpdateRequest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get Requests with pagination
     * @param filter The Request filter
     */
    request_RequestList(filter: DashboardFilterDto): Promise<PaginatedListOfRequestDto> {
        let url_ = this.baseUrl + "/Request/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_RequestList(_response));
        });
    }

    protected processRequest_RequestList(response: Response): Promise<PaginatedListOfRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfRequestDto>(null as any);
    }

    /**
     * Get Requests with pagination for list builder
     * @param filter The Request list builder filter
     * @return A paginated list of requests
     */
    request_RequestListBuilder(filter: ListBuilderFilter): Promise<PaginatedListOfRequestDto> {
        let url_ = this.baseUrl + "/Request/ListBuilder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_RequestListBuilder(_response));
        });
    }

    protected processRequest_RequestListBuilder(response: Response): Promise<PaginatedListOfRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfRequestDto>(null as any);
    }

    /**
     * Get summary card for User
     * @param dateRange_From (optional) 
     * @param dateRange_To (optional) 
     * @param hideParentRequests (optional) 
     */
    request_UserSummaryCard(dateRange_From: Date | null | undefined, dateRange_To: Date | null | undefined, hideParentRequests: boolean | undefined): Promise<UserSummaryCard> {
        let url_ = this.baseUrl + "/Request/UserSummaryCard?";
        if (dateRange_From !== undefined && dateRange_From !== null)
            url_ += "DateRange.From=" + encodeURIComponent(dateRange_From ? "" + dateRange_From.toISOString() : "") + "&";
        if (dateRange_To !== undefined && dateRange_To !== null)
            url_ += "DateRange.To=" + encodeURIComponent(dateRange_To ? "" + dateRange_To.toISOString() : "") + "&";
        if (hideParentRequests === null)
            throw new Error("The parameter 'hideParentRequests' cannot be null.");
        else if (hideParentRequests !== undefined)
            url_ += "HideParentRequests=" + encodeURIComponent("" + hideParentRequests) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_UserSummaryCard(_response));
        });
    }

    protected processRequest_UserSummaryCard(response: Response): Promise<UserSummaryCard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSummaryCard.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSummaryCard>(null as any);
    }

    request_UserListSummary(filters: ListQueryDto[]): Promise<ListCount[]> {
        let url_ = this.baseUrl + "/Request/UserListSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_UserListSummary(_response));
        });
    }

    protected processRequest_UserListSummary(response: Response): Promise<ListCount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListCount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListCount[]>(null as any);
    }

    /**
     * Get Requests with pagination
     * @param filter The Request filter
     */
    request_BookmarkRequestList(filter: DashboardFilterDto): Promise<PaginatedListOfRequestDto> {
        let url_ = this.baseUrl + "/Request/bookmark/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_BookmarkRequestList(_response));
        });
    }

    protected processRequest_BookmarkRequestList(response: Response): Promise<PaginatedListOfRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfRequestDto>(null as any);
    }

    /**
     * Bookmark/Star a particular request for Current User
     * @param requestId The universal request Id, that needs to be bookmarked
     */
    request_BookmarkRequest(requestId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/Request/bookmark/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_BookmarkRequest(_response));
        });
    }

    protected processRequest_BookmarkRequest(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Remove the Request from User's bookmark list
     * @param requestId The universal request Id, that needs to be bookmarked
     */
    request_BookmarkRequestDelete(requestId: string): Promise<void> {
        let url_ = this.baseUrl + "/Request/bookmark/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_BookmarkRequestDelete(_response));
        });
    }

    protected processRequest_BookmarkRequestDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    request_GetCachedRequest(draftId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Request/Draft?";
        if (draftId !== undefined && draftId !== null)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_GetCachedRequest(_response));
        });
    }

    protected processRequest_GetCachedRequest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    request_SetCachedRequest(draftId: string | null | undefined, adoptLegacyDraft: boolean | undefined, requestData: string): Promise<boolean> {
        let url_ = this.baseUrl + "/Request/Draft?";
        if (draftId !== undefined && draftId !== null)
            url_ += "draftId=" + encodeURIComponent("" + draftId) + "&";
        if (adoptLegacyDraft === null)
            throw new Error("The parameter 'adoptLegacyDraft' cannot be null.");
        else if (adoptLegacyDraft !== undefined)
            url_ += "adoptLegacyDraft=" + encodeURIComponent("" + adoptLegacyDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestData);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_SetCachedRequest(_response));
        });
    }

    protected processRequest_SetCachedRequest(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Unlinks child requests to a parent request
     * @param dto Dto for unlinking requests, contains unified tracking id for children requests and the unified tracking id of the parent request that is being unlinked from
     */
    request_UnassociateRequest(dto: AssociateRequestDto): Promise<RequestDto> {
        let url_ = this.baseUrl + "/Request/UnassociateRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_UnassociateRequest(_response));
        });
    }

    protected processRequest_UnassociateRequest(response: Response): Promise<RequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestDto>(null as any);
    }

    /**
     * Associates child requests to a parent request
     * @param dto Dto for associating requests, contains unified tracking id's for children requests and the unified tracking id of the parent request that is being associated to
     * @return A list of the children associated to the parent
     */
    request_AssociateRequests(dto: AssociateRequestsDto): Promise<RequestDto[]> {
        let url_ = this.baseUrl + "/Request/AssociateRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_AssociateRequests(_response));
        });
    }

    protected processRequest_AssociateRequests(response: Response): Promise<RequestDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestDto[]>(null as any);
    }

    /**
     * Hides the particular request. Only Admins can hit utilize this API
     * @param requestId The universal request Id, that needs to be hidden
     */
    request_HideRequest(requestId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/Request/hide/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_HideRequest(_response));
        });
    }

    protected processRequest_HideRequest(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Un-Hides the particular request. Only Admins can hit utilize this API
     * @param requestId The universal request Id, that needs to be un-hidden
     */
    request_UnHideRequest(requestId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/Request/unhide/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_UnHideRequest(_response));
        });
    }

    protected processRequest_UnHideRequest(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    request_UpdateTagInRequest(requestId: string, tags: TagDto[]): Promise<boolean> {
        let url_ = this.baseUrl + "/Request/{requestId}/tag";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tags);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_UpdateTagInRequest(_response));
        });
    }

    protected processRequest_UpdateTagInRequest(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    request_RemoveTagFromRequest(requestId: string, tag: TagDto): Promise<void> {
        let url_ = this.baseUrl + "/Request/{requestId}/tag";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tag);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_RemoveTagFromRequest(_response));
        });
    }

    protected processRequest_RemoveTagFromRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    request_UpdateStatusRequest(dto: EditStatusDto): Promise<Unit> {
        let url_ = this.baseUrl + "/Request/StatusUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_UpdateStatusRequest(_response));
        });
    }

    protected processRequest_UpdateStatusRequest(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }

    request_UpdateDevices(dto: EditDevicesDto): Promise<boolean> {
        let url_ = this.baseUrl + "/Request/DevicesUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_UpdateDevices(_response));
        });
    }

    protected processRequest_UpdateDevices(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Download the results of a List Builder query
     * @param filter The List Builder filters
     * @return File
     */
    request_GetDownloadVisualFlowById(filter: ListQueryDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Request/DownloadListBuilderItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequest_GetDownloadVisualFlowById(_response));
        });
    }

    protected processRequest_GetDownloadVisualFlowById(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get Status with pagination
     * @param statusText (optional) 
     * @param correlationId (optional) 
     * @param parentStatusId (optional) 
     * @param entityType (optional) 
     * @param id (optional) 
     * @param isActive (optional) 
     * @param isInternal (optional) 
     * @param isExternal (optional) 
     * @param dateRange_From (optional) 
     * @param dateRange_To (optional) 
     * @param sortProperty (optional) 
     * @param sortDirection (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    status_GetStatusList(statusText: string | null | undefined, correlationId: string | null | undefined, parentStatusId: string | null | undefined, entityType: EntityType | undefined, id: string | null | undefined, isActive: boolean | null | undefined, isInternal: boolean | null | undefined, isExternal: boolean | null | undefined, dateRange_From: Date | undefined, dateRange_To: Date | undefined, sortProperty: string | null | undefined, sortDirection: ListSortDirection | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfStatusResponseDto> {
        let url_ = this.baseUrl + "/request/Status/list?";
        if (statusText !== undefined && statusText !== null)
            url_ += "StatusText=" + encodeURIComponent("" + statusText) + "&";
        if (correlationId !== undefined && correlationId !== null)
            url_ += "CorrelationId=" + encodeURIComponent("" + correlationId) + "&";
        if (parentStatusId !== undefined && parentStatusId !== null)
            url_ += "ParentStatusId=" + encodeURIComponent("" + parentStatusId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isInternal !== undefined && isInternal !== null)
            url_ += "IsInternal=" + encodeURIComponent("" + isInternal) + "&";
        if (isExternal !== undefined && isExternal !== null)
            url_ += "IsExternal=" + encodeURIComponent("" + isExternal) + "&";
        if (dateRange_From === null)
            throw new Error("The parameter 'dateRange_From' cannot be null.");
        else if (dateRange_From !== undefined)
            url_ += "DateRange.From=" + encodeURIComponent(dateRange_From ? "" + dateRange_From.toISOString() : "") + "&";
        if (dateRange_To === null)
            throw new Error("The parameter 'dateRange_To' cannot be null.");
        else if (dateRange_To !== undefined)
            url_ += "DateRange.To=" + encodeURIComponent(dateRange_To ? "" + dateRange_To.toISOString() : "") + "&";
        if (sortProperty !== undefined && sortProperty !== null)
            url_ += "SortProperty=" + encodeURIComponent("" + sortProperty) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStatus_GetStatusList(_response));
        });
    }

    protected processStatus_GetStatusList(response: Response): Promise<PaginatedListOfStatusResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfStatusResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfStatusResponseDto>(null as any);
    }

    /**
     * Create Status
     * @param statusDto Status dto
     * @return StatusId on success (GUID)
     */
    status_CreateStatus(statusDto: CreateStatusDto): Promise<string> {
        let url_ = this.baseUrl + "/request/Status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statusDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStatus_CreateStatus(_response));
        });
    }

    protected processStatus_CreateStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Remove Status
     * @param id (optional) Status Id
     * @param correlationId (optional) UnifiedTracking Id
     * @return StatusId on success (GUID)
     */
    status_RemoveStatus(id: string | undefined, correlationId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/request/Status?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (correlationId !== undefined && correlationId !== null)
            url_ += "correlationId=" + encodeURIComponent("" + correlationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStatus_RemoveStatus(_response));
        });
    }

    protected processStatus_RemoveStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Creates the same Status for multiple requests.
    Primarily used for parent/child relationships
     * @param statusesDto Statuses dto
     * @return true if successful
     */
    status_CreateStatuses(statusesDto: CreateStatusesDto): Promise<void> {
        let url_ = this.baseUrl + "/request/Status/Statuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statusesDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStatus_CreateStatuses(_response));
        });
    }

    protected processStatus_CreateStatuses(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * update status response
     * @param statusDto status dto
     */
    status_UpdateStatus(statusDto: CreateStatusDto): Promise<boolean> {
        let url_ = this.baseUrl + "/request/Status/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statusDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStatus_UpdateStatus(_response));
        });
    }

    protected processStatus_UpdateStatus(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    tag_RequestList(): Promise<TagDto[]> {
        let url_ = this.baseUrl + "/request/Tag/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTag_RequestList(_response));
        });
    }

    protected processTag_RequestList(response: Response): Promise<TagDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagDto[]>(null as any);
    }

    tag_CreateTag(tag: TagDto): Promise<void> {
        let url_ = this.baseUrl + "/request/Tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tag);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTag_CreateTag(_response));
        });
    }

    protected processTag_CreateTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    tag_DeleteTag(id: string): Promise<void> {
        let url_ = this.baseUrl + "/request/Tag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTag_DeleteTag(_response));
        });
    }

    protected processTag_DeleteTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    user_GetSearchGroupMembers(requestDomain: RequestDomain | undefined, maxResultCount: number | undefined): Promise<GraphUserDto[]> {
        let url_ = this.baseUrl + "/request/User/SearchGroup?";
        if (requestDomain === null)
            throw new Error("The parameter 'requestDomain' cannot be null.");
        else if (requestDomain !== undefined)
            url_ += "requestDomain=" + encodeURIComponent("" + requestDomain) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUser_GetSearchGroupMembers(_response));
        });
    }

    protected processUser_GetSearchGroupMembers(response: Response): Promise<GraphUserDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GraphUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GraphUserDto[]>(null as any);
    }

    /**
     * Get the visual flow activity list
     * @return List of ActivityDto
     */
    visualFlow_GetVisualFlowById(id: string): Promise<VisualFlowDto> {
        let url_ = this.baseUrl + "/request/VisualFlow/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVisualFlow_GetVisualFlowById(_response));
        });
    }

    protected processVisualFlow_GetVisualFlowById(response: Response): Promise<VisualFlowDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VisualFlowDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VisualFlowDto>(null as any);
    }

    /**
     * Download the visual flow
     * @param id SkpId
     * @return DownloadVisualFlowDto
     */
    visualFlow_GetDownloadVisualFlowById(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/request/VisualFlow/{id}/DownloadVisualFlow";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVisualFlow_GetDownloadVisualFlowById(_response));
        });
    }

    protected processVisualFlow_GetDownloadVisualFlowById(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DeviceCategory implements IDeviceCategory {
    id?: number;
    name?: string | undefined;
    iconUrl?: string | undefined;
    sortOrder?: number;
    devices?: DeviceModel[] | undefined;

    constructor(data?: IDeviceCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.iconUrl = _data["iconUrl"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceCategory {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["iconUrl"] = this.iconUrl;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IDeviceCategory {
    id?: number;
    name?: string | undefined;
    iconUrl?: string | undefined;
    sortOrder?: number;
    devices?: DeviceModel[] | undefined;
}

export class DeviceModel implements IDeviceModel {
    id?: number;
    name?: string | undefined;
    sortOrder?: number;
    iconUrl?: string | undefined;
    isAdded?: boolean | undefined;
    count?: number | undefined;

    constructor(data?: IDeviceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.iconUrl = _data["iconUrl"];
            this.isAdded = _data["isAdded"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): DeviceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["iconUrl"] = this.iconUrl;
        data["isAdded"] = this.isAdded;
        data["count"] = this.count;
        return data;
    }
}

export interface IDeviceModel {
    id?: number;
    name?: string | undefined;
    sortOrder?: number;
    iconUrl?: string | undefined;
    isAdded?: boolean | undefined;
    count?: number | undefined;
}

export class IndustryMaster implements IIndustryMaster {
    id?: number;
    name?: string | undefined;

    constructor(data?: IIndustryMaster) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IndustryMaster {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryMaster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IIndustryMaster {
    id?: number;
    name?: string | undefined;
}

export class EnumLookUp implements IEnumLookUp {
    id?: number;
    name?: string | undefined;

    constructor(data?: IEnumLookUp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EnumLookUp {
        data = typeof data === 'object' ? data : {};
        let result = new EnumLookUp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEnumLookUp {
    id?: number;
    name?: string | undefined;
}

/** Msx Static Data */
export class MsxStaticData implements IMsxStaticData {
    customerName?: string | undefined;
    applicationId?: string | undefined;
    opportunityId?: string | undefined;
    tpId?: string | undefined;
    crmId?: string | undefined;
    country?: string | undefined;
    region?: string | undefined;
    industry?: string | undefined;
    deviceCount?: number;
    revenue?: number;

    constructor(data?: IMsxStaticData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.applicationId = _data["applicationId"];
            this.opportunityId = _data["opportunityId"];
            this.tpId = _data["tpId"];
            this.crmId = _data["crmId"];
            this.country = _data["country"];
            this.region = _data["region"];
            this.industry = _data["industry"];
            this.deviceCount = _data["deviceCount"];
            this.revenue = _data["revenue"];
        }
    }

    static fromJS(data: any): MsxStaticData {
        data = typeof data === 'object' ? data : {};
        let result = new MsxStaticData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["applicationId"] = this.applicationId;
        data["opportunityId"] = this.opportunityId;
        data["tpId"] = this.tpId;
        data["crmId"] = this.crmId;
        data["country"] = this.country;
        data["region"] = this.region;
        data["industry"] = this.industry;
        data["deviceCount"] = this.deviceCount;
        data["revenue"] = this.revenue;
        return data;
    }
}

/** Msx Static Data */
export interface IMsxStaticData {
    customerName?: string | undefined;
    applicationId?: string | undefined;
    opportunityId?: string | undefined;
    tpId?: string | undefined;
    crmId?: string | undefined;
    country?: string | undefined;
    region?: string | undefined;
    industry?: string | undefined;
    deviceCount?: number;
    revenue?: number;
}

export class RequestTypeDetailsDto implements IRequestTypeDetailsDto {
    requestTeamId?: number;
    requestType?: EnumLookUp[] | undefined;
    fieldTypeDetail?: FieldTypeDetail[] | undefined;

    constructor(data?: IRequestTypeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestTeamId = _data["requestTeamId"];
            if (Array.isArray(_data["requestType"])) {
                this.requestType = [] as any;
                for (let item of _data["requestType"])
                    this.requestType!.push(EnumLookUp.fromJS(item));
            }
            if (Array.isArray(_data["fieldTypeDetail"])) {
                this.fieldTypeDetail = [] as any;
                for (let item of _data["fieldTypeDetail"])
                    this.fieldTypeDetail!.push(FieldTypeDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestTypeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestTypeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestTeamId"] = this.requestTeamId;
        if (Array.isArray(this.requestType)) {
            data["requestType"] = [];
            for (let item of this.requestType)
                data["requestType"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.fieldTypeDetail)) {
            data["fieldTypeDetail"] = [];
            for (let item of this.fieldTypeDetail)
                data["fieldTypeDetail"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRequestTypeDetailsDto {
    requestTeamId?: number;
    requestType?: EnumLookUp[] | undefined;
    fieldTypeDetail?: FieldTypeDetail[] | undefined;
}

export class FieldTypeDetail implements IFieldTypeDetail {
    requestTypeId?: number;
    requestTypeName?: string | undefined;
    criticality?: EnumLookUp[] | undefined;
    impactReach?: EnumLookUp[] | undefined;
    productCategory?: EnumLookUp[] | undefined;
    pfrSubtype?: EnumLookUp[] | undefined;
    bugInformation?: EnumLookUp[] | undefined;
    priority?: EnumLookUp[] | undefined;
    caseCodeInvestigation?: EnumLookUp[] | undefined;
    caseCodeRequest?: EnumLookUp[] | undefined;
    mainRequestType?: EnumLookUp[] | undefined;
    subRequestType?: EnumLookUp[] | undefined;
    taskStatus?: EnumLookUp[] | undefined;

    constructor(data?: IFieldTypeDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestTypeId = _data["requestTypeId"];
            this.requestTypeName = _data["requestTypeName"];
            if (Array.isArray(_data["criticality"])) {
                this.criticality = [] as any;
                for (let item of _data["criticality"])
                    this.criticality!.push(EnumLookUp.fromJS(item));
            }
            if (Array.isArray(_data["impactReach"])) {
                this.impactReach = [] as any;
                for (let item of _data["impactReach"])
                    this.impactReach!.push(EnumLookUp.fromJS(item));
            }
            if (Array.isArray(_data["productCategory"])) {
                this.productCategory = [] as any;
                for (let item of _data["productCategory"])
                    this.productCategory!.push(EnumLookUp.fromJS(item));
            }
            if (Array.isArray(_data["pfrSubtype"])) {
                this.pfrSubtype = [] as any;
                for (let item of _data["pfrSubtype"])
                    this.pfrSubtype!.push(EnumLookUp.fromJS(item));
            }
            if (Array.isArray(_data["bugInformation"])) {
                this.bugInformation = [] as any;
                for (let item of _data["bugInformation"])
                    this.bugInformation!.push(EnumLookUp.fromJS(item));
            }
            if (Array.isArray(_data["priority"])) {
                this.priority = [] as any;
                for (let item of _data["priority"])
                    this.priority!.push(EnumLookUp.fromJS(item));
            }
            if (Array.isArray(_data["caseCodeInvestigation"])) {
                this.caseCodeInvestigation = [] as any;
                for (let item of _data["caseCodeInvestigation"])
                    this.caseCodeInvestigation!.push(EnumLookUp.fromJS(item));
            }
            if (Array.isArray(_data["caseCodeRequest"])) {
                this.caseCodeRequest = [] as any;
                for (let item of _data["caseCodeRequest"])
                    this.caseCodeRequest!.push(EnumLookUp.fromJS(item));
            }
            if (Array.isArray(_data["mainRequestType"])) {
                this.mainRequestType = [] as any;
                for (let item of _data["mainRequestType"])
                    this.mainRequestType!.push(EnumLookUp.fromJS(item));
            }
            if (Array.isArray(_data["subRequestType"])) {
                this.subRequestType = [] as any;
                for (let item of _data["subRequestType"])
                    this.subRequestType!.push(EnumLookUp.fromJS(item));
            }
            if (Array.isArray(_data["taskStatus"])) {
                this.taskStatus = [] as any;
                for (let item of _data["taskStatus"])
                    this.taskStatus!.push(EnumLookUp.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldTypeDetail {
        data = typeof data === 'object' ? data : {};
        let result = new FieldTypeDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestTypeId"] = this.requestTypeId;
        data["requestTypeName"] = this.requestTypeName;
        if (Array.isArray(this.criticality)) {
            data["criticality"] = [];
            for (let item of this.criticality)
                data["criticality"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.impactReach)) {
            data["impactReach"] = [];
            for (let item of this.impactReach)
                data["impactReach"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.productCategory)) {
            data["productCategory"] = [];
            for (let item of this.productCategory)
                data["productCategory"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.pfrSubtype)) {
            data["pfrSubtype"] = [];
            for (let item of this.pfrSubtype)
                data["pfrSubtype"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.bugInformation)) {
            data["bugInformation"] = [];
            for (let item of this.bugInformation)
                data["bugInformation"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.priority)) {
            data["priority"] = [];
            for (let item of this.priority)
                data["priority"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.caseCodeInvestigation)) {
            data["caseCodeInvestigation"] = [];
            for (let item of this.caseCodeInvestigation)
                data["caseCodeInvestigation"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.caseCodeRequest)) {
            data["caseCodeRequest"] = [];
            for (let item of this.caseCodeRequest)
                data["caseCodeRequest"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.mainRequestType)) {
            data["mainRequestType"] = [];
            for (let item of this.mainRequestType)
                data["mainRequestType"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.subRequestType)) {
            data["subRequestType"] = [];
            for (let item of this.subRequestType)
                data["subRequestType"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.taskStatus)) {
            data["taskStatus"] = [];
            for (let item of this.taskStatus)
                data["taskStatus"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IFieldTypeDetail {
    requestTypeId?: number;
    requestTypeName?: string | undefined;
    criticality?: EnumLookUp[] | undefined;
    impactReach?: EnumLookUp[] | undefined;
    productCategory?: EnumLookUp[] | undefined;
    pfrSubtype?: EnumLookUp[] | undefined;
    bugInformation?: EnumLookUp[] | undefined;
    priority?: EnumLookUp[] | undefined;
    caseCodeInvestigation?: EnumLookUp[] | undefined;
    caseCodeRequest?: EnumLookUp[] | undefined;
    mainRequestType?: EnumLookUp[] | undefined;
    subRequestType?: EnumLookUp[] | undefined;
    taskStatus?: EnumLookUp[] | undefined;
}

export class CountryMaster implements ICountryMaster {
    id?: number;
    name?: string | undefined;
    dialingCode?: string | undefined;

    constructor(data?: ICountryMaster) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dialingCode = _data["dialingCode"];
        }
    }

    static fromJS(data: any): CountryMaster {
        data = typeof data === 'object' ? data : {};
        let result = new CountryMaster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dialingCode"] = this.dialingCode;
        return data;
    }
}

export interface ICountryMaster {
    id?: number;
    name?: string | undefined;
    dialingCode?: string | undefined;
}

export class ProductAreaCategory implements IProductAreaCategory {
    id?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    sortOrder?: number;
    subCategories?: ProductAreaSubCategory[] | undefined;

    constructor(data?: IProductAreaCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["subCategories"])) {
                this.subCategories = [] as any;
                for (let item of _data["subCategories"])
                    this.subCategories!.push(ProductAreaSubCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductAreaCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAreaCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.subCategories)) {
            data["subCategories"] = [];
            for (let item of this.subCategories)
                data["subCategories"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IProductAreaCategory {
    id?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    sortOrder?: number;
    subCategories?: ProductAreaSubCategory[] | undefined;
}

export class ProductAreaSubCategory implements IProductAreaSubCategory {
    id?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    sortOrder?: number;
    products?: ProductAreaItem[] | undefined;

    constructor(data?: IProductAreaSubCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductAreaItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductAreaSubCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAreaSubCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IProductAreaSubCategory {
    id?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    sortOrder?: number;
    products?: ProductAreaItem[] | undefined;
}

export class ProductAreaItem implements IProductAreaItem {
    id?: string | undefined;
    name?: string | undefined;
    isOtherSpecify?: boolean;
    deviceModelId?: number | undefined;
    deviceCategoryId?: number | undefined;

    constructor(data?: IProductAreaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isOtherSpecify = _data["isOtherSpecify"];
            this.deviceModelId = _data["deviceModelId"];
            this.deviceCategoryId = _data["deviceCategoryId"];
        }
    }

    static fromJS(data: any): ProductAreaItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAreaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isOtherSpecify"] = this.isOtherSpecify;
        data["deviceModelId"] = this.deviceModelId;
        data["deviceCategoryId"] = this.deviceCategoryId;
        return data;
    }
}

export interface IProductAreaItem {
    id?: string | undefined;
    name?: string | undefined;
    isOtherSpecify?: boolean;
    deviceModelId?: number | undefined;
    deviceCategoryId?: number | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ReassignRequestDto implements IReassignRequestDto {
    currentTeam?: RequestDomain;
    currentRequestType?: RequestType;
    reassignTeam?: RequestDomain;
    reassignRequestType?: RequestType;
    requestedResolutionDate?: Date | undefined;
    requestId?: string | undefined;
    reasonForReassignment?: number;
    isSameTeamReassignment?: boolean;
    isParent?: boolean | undefined;
    cssCaseNumber?: string | undefined;
    parentRequestId?: string | undefined;
    customerFamilySubmissionId?: string | undefined;
    customerFamilyGeneration?: number | undefined;

    constructor(data?: IReassignRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentTeam = _data["currentTeam"];
            this.currentRequestType = _data["currentRequestType"];
            this.reassignTeam = _data["reassignTeam"];
            this.reassignRequestType = _data["reassignRequestType"];
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.requestId = _data["requestId"];
            this.reasonForReassignment = _data["reasonForReassignment"];
            this.isSameTeamReassignment = _data["isSameTeamReassignment"];
            this.isParent = _data["isParent"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.parentRequestId = _data["parentRequestId"];
            this.customerFamilySubmissionId = _data["customerFamilySubmissionId"];
            this.customerFamilyGeneration = _data["customerFamilyGeneration"];
        }
    }

    static fromJS(data: any): ReassignRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReassignRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentTeam"] = this.currentTeam;
        data["currentRequestType"] = this.currentRequestType;
        data["reassignTeam"] = this.reassignTeam;
        data["reassignRequestType"] = this.reassignRequestType;
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["requestId"] = this.requestId;
        data["reasonForReassignment"] = this.reasonForReassignment;
        data["isSameTeamReassignment"] = this.isSameTeamReassignment;
        data["isParent"] = this.isParent;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["parentRequestId"] = this.parentRequestId;
        data["customerFamilySubmissionId"] = this.customerFamilySubmissionId;
        data["customerFamilyGeneration"] = this.customerFamilyGeneration;
        return data;
    }
}

export interface IReassignRequestDto {
    currentTeam?: RequestDomain;
    currentRequestType?: RequestType;
    reassignTeam?: RequestDomain;
    reassignRequestType?: RequestType;
    requestedResolutionDate?: Date | undefined;
    requestId?: string | undefined;
    reasonForReassignment?: number;
    isSameTeamReassignment?: boolean;
    isParent?: boolean | undefined;
    cssCaseNumber?: string | undefined;
    parentRequestId?: string | undefined;
    customerFamilySubmissionId?: string | undefined;
    customerFamilyGeneration?: number | undefined;
}

export enum RequestDomain {
    SDSG = 1,
    CXP = 2,
    CSS = 3,
    Crew = 4,
    Admin = 5,
}

export enum RequestType {
    Proposal = 1,
    Question = 2,
    Rfx = 3,
    PreSales = 4,
    PostSales = 5,
    CSSRequest = 6,
    CssReviewRequest = 7,
    CXP_VariantRequest = 8,
    CXP_PFR_Request = 9,
    CXP_MessagingRequest = 10,
    CXP_TechnicalRequest = 11,
    CXP_ProgramRequest = 12,
    CREW_WarrantyRequest = 13,
    CREW_ProductRequest = 14,
    CREW_MessagingRequest = 15,
}

export class RouteResponse implements IRouteResponse {
    requestType?: number;

    constructor(data?: IRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestType = _data["requestType"];
        }
    }

    static fromJS(data: any): RouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestType"] = this.requestType;
        return data;
    }
}

export interface IRouteResponse {
    requestType?: number;
}

export class RouteRequest implements IRouteRequest {
    title?: string | undefined;
    description?: string | undefined;
    requestDomain?: number | undefined;

    constructor(data?: IRouteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.requestDomain = _data["requestDomain"];
        }
    }

    static fromJS(data: any): RouteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RouteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["requestDomain"] = this.requestDomain;
        return data;
    }
}

export interface IRouteRequest {
    title?: string | undefined;
    description?: string | undefined;
    requestDomain?: number | undefined;
}

export class CreateFeedbackDto implements ICreateFeedbackDto {
    feedbackMessage?: string | undefined;
    experience?: string | undefined;
    feedbackCategory?: FeedbackCategory;
    requestId?: string | undefined;

    constructor(data?: ICreateFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feedbackMessage = _data["feedbackMessage"];
            this.experience = _data["experience"];
            this.feedbackCategory = _data["feedbackCategory"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): CreateFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedbackMessage"] = this.feedbackMessage;
        data["experience"] = this.experience;
        data["feedbackCategory"] = this.feedbackCategory;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface ICreateFeedbackDto {
    feedbackMessage?: string | undefined;
    experience?: string | undefined;
    feedbackCategory?: FeedbackCategory;
    requestId?: string | undefined;
}

export enum FeedbackCategory {
    Suggestion = 1,
    Compliment = 2,
    ReportABug = 3,
    Request = 4,
}

export class FeedbackResponseDto implements IFeedbackResponseDto {
    id?: string;
    feedbackMessage?: string | undefined;
    experience?: string | undefined;
    feedbackCategory?: FeedbackCategory;
    requestId?: string | undefined;
    adminResponse?: string | undefined;
    adminRespondedOn?: Date | undefined;
    createdBy?: UserDto | undefined;
    createdOn?: Date;
    modifiedBy?: UserDto | undefined;

    constructor(data?: IFeedbackResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.feedbackMessage = _data["feedbackMessage"];
            this.experience = _data["experience"];
            this.feedbackCategory = _data["feedbackCategory"];
            this.requestId = _data["requestId"];
            this.adminResponse = _data["adminResponse"];
            this.adminRespondedOn = _data["adminRespondedOn"] ? new Date(_data["adminRespondedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"] ? UserDto.fromJS(_data["modifiedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeedbackResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["feedbackMessage"] = this.feedbackMessage;
        data["experience"] = this.experience;
        data["feedbackCategory"] = this.feedbackCategory;
        data["requestId"] = this.requestId;
        data["adminResponse"] = this.adminResponse;
        data["adminRespondedOn"] = this.adminRespondedOn ? this.adminRespondedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeedbackResponseDto {
    id?: string;
    feedbackMessage?: string | undefined;
    experience?: string | undefined;
    feedbackCategory?: FeedbackCategory;
    requestId?: string | undefined;
    adminResponse?: string | undefined;
    adminRespondedOn?: Date | undefined;
    createdBy?: UserDto | undefined;
    createdOn?: Date;
    modifiedBy?: UserDto | undefined;
}

export class UserDto implements IUserDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    userRoles?: UserRole[] | undefined;
    contactNumber?: string | undefined;
    profilePic?: string | undefined;
    businessPhones?: string[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.userDomain = _data["userDomain"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.contactNumber = _data["contactNumber"];
            this.profilePic = _data["profilePic"];
            if (Array.isArray(_data["businessPhones"])) {
                this.businessPhones = [] as any;
                for (let item of _data["businessPhones"])
                    this.businessPhones!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["userDomain"] = this.userDomain;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : <any>undefined);
        }
        data["contactNumber"] = this.contactNumber;
        data["profilePic"] = this.profilePic;
        if (Array.isArray(this.businessPhones)) {
            data["businessPhones"] = [];
            for (let item of this.businessPhones)
                data["businessPhones"].push(item);
        }
        return data;
    }
}

export interface IUserDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    userRoles?: UserRole[] | undefined;
    contactNumber?: string | undefined;
    profilePic?: string | undefined;
    businessPhones?: string[] | undefined;
}

export class UserRole implements IUserRole {
    roleName?: string | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserRole {
    roleName?: string | undefined;
}

export class PaginatedListOfCommentResponseDto implements IPaginatedListOfCommentResponseDto {
    items?: CommentResponseDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCommentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CommentResponseDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCommentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCommentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCommentResponseDto {
    items?: CommentResponseDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CommentResponseDto implements ICommentResponseDto {
    id?: string;
    commentText?: string | undefined;
    correlationId?: string | undefined;
    entityType?: EntityType;
    parentCommentId?: string | undefined;
    childComments?: CommentResponseDto[] | undefined;
    taggedUsers?: UserDto[] | undefined;
    emotes?: EmoteDto[] | undefined;
    isActive?: boolean | undefined;
    isInternal?: boolean;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;

    constructor(data?: ICommentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commentText = _data["commentText"];
            this.correlationId = _data["correlationId"];
            this.entityType = _data["entityType"];
            this.parentCommentId = _data["parentCommentId"];
            if (Array.isArray(_data["childComments"])) {
                this.childComments = [] as any;
                for (let item of _data["childComments"])
                    this.childComments!.push(CommentResponseDto.fromJS(item));
            }
            if (Array.isArray(_data["taggedUsers"])) {
                this.taggedUsers = [] as any;
                for (let item of _data["taggedUsers"])
                    this.taggedUsers!.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["emotes"])) {
                this.emotes = [] as any;
                for (let item of _data["emotes"])
                    this.emotes!.push(EmoteDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.isInternal = _data["isInternal"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"] ? UserDto.fromJS(_data["modifiedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commentText"] = this.commentText;
        data["correlationId"] = this.correlationId;
        data["entityType"] = this.entityType;
        data["parentCommentId"] = this.parentCommentId;
        if (Array.isArray(this.childComments)) {
            data["childComments"] = [];
            for (let item of this.childComments)
                data["childComments"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.taggedUsers)) {
            data["taggedUsers"] = [];
            for (let item of this.taggedUsers)
                data["taggedUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.emotes)) {
            data["emotes"] = [];
            for (let item of this.emotes)
                data["emotes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isActive"] = this.isActive;
        data["isInternal"] = this.isInternal;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommentResponseDto {
    id?: string;
    commentText?: string | undefined;
    correlationId?: string | undefined;
    entityType?: EntityType;
    parentCommentId?: string | undefined;
    childComments?: CommentResponseDto[] | undefined;
    taggedUsers?: UserDto[] | undefined;
    emotes?: EmoteDto[] | undefined;
    isActive?: boolean | undefined;
    isInternal?: boolean;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;
}

export enum EntityType {
    HelpRequest = 1,
    Feedback = 2,
    Article = 3,
    Comment = 4,
    Report = 5,
    Status = 6,
}

export class EmoteDto implements IEmoteDto {
    reaction?: EmoteReaction;
    user?: UserDto | undefined;

    constructor(data?: IEmoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reaction = _data["reaction"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reaction"] = this.reaction;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmoteDto {
    reaction?: EmoteReaction;
    user?: UserDto | undefined;
}

export enum EmoteReaction {
    Like = 1,
    Love = 2,
    Laugh = 3,
    Shock = 4,
    Angry = 5,
}

export enum ListSortDirection {
    Ascending = 0,
    Descending = 1,
}

export class CreateCommentDto implements ICreateCommentDto {
    commentText?: string | undefined;
    correlationId?: string | undefined;
    entityType?: EntityType;
    taggedUsers?: UserDto[] | undefined;
    parentCommentId?: string | undefined;
    isInternal?: boolean;

    constructor(data?: ICreateCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentText = _data["commentText"];
            this.correlationId = _data["correlationId"];
            this.entityType = _data["entityType"];
            if (Array.isArray(_data["taggedUsers"])) {
                this.taggedUsers = [] as any;
                for (let item of _data["taggedUsers"])
                    this.taggedUsers!.push(UserDto.fromJS(item));
            }
            this.parentCommentId = _data["parentCommentId"];
            this.isInternal = _data["isInternal"];
        }
    }

    static fromJS(data: any): CreateCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentText"] = this.commentText;
        data["correlationId"] = this.correlationId;
        data["entityType"] = this.entityType;
        if (Array.isArray(this.taggedUsers)) {
            data["taggedUsers"] = [];
            for (let item of this.taggedUsers)
                data["taggedUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["parentCommentId"] = this.parentCommentId;
        data["isInternal"] = this.isInternal;
        return data;
    }
}

export interface ICreateCommentDto {
    commentText?: string | undefined;
    correlationId?: string | undefined;
    entityType?: EntityType;
    taggedUsers?: UserDto[] | undefined;
    parentCommentId?: string | undefined;
    isInternal?: boolean;
}

export class CommentDto implements ICommentDto {
    commentText?: string | undefined;
    correlationId?: string | undefined;
    entityType?: EntityType;
    isInternal?: boolean;
    taggedUsers?: UserDto[] | undefined;
    emotes?: EmoteDto[] | undefined;
    parentCommentId?: string;

    constructor(data?: ICommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentText = _data["commentText"];
            this.correlationId = _data["correlationId"];
            this.entityType = _data["entityType"];
            this.isInternal = _data["isInternal"];
            if (Array.isArray(_data["taggedUsers"])) {
                this.taggedUsers = [] as any;
                for (let item of _data["taggedUsers"])
                    this.taggedUsers!.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["emotes"])) {
                this.emotes = [] as any;
                for (let item of _data["emotes"])
                    this.emotes!.push(EmoteDto.fromJS(item));
            }
            this.parentCommentId = _data["parentCommentId"];
        }
    }

    static fromJS(data: any): CommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentText"] = this.commentText;
        data["correlationId"] = this.correlationId;
        data["entityType"] = this.entityType;
        data["isInternal"] = this.isInternal;
        if (Array.isArray(this.taggedUsers)) {
            data["taggedUsers"] = [];
            for (let item of this.taggedUsers)
                data["taggedUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.emotes)) {
            data["emotes"] = [];
            for (let item of this.emotes)
                data["emotes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["parentCommentId"] = this.parentCommentId;
        return data;
    }
}

export interface ICommentDto {
    commentText?: string | undefined;
    correlationId?: string | undefined;
    entityType?: EntityType;
    isInternal?: boolean;
    taggedUsers?: UserDto[] | undefined;
    emotes?: EmoteDto[] | undefined;
    parentCommentId?: string;
}

/** Represents a void type, since Void is not a valid return type in C#. */
export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Represents a void type, since Void is not a valid return type in C#. */
export interface IUnit {
}

export class AddEmoteDto implements IAddEmoteDto {
    emote?: EmoteDto | undefined;
    commentId?: string | undefined;

    constructor(data?: IAddEmoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emote = _data["emote"] ? EmoteDto.fromJS(_data["emote"]) : <any>undefined;
            this.commentId = _data["commentId"];
        }
    }

    static fromJS(data: any): AddEmoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddEmoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emote"] = this.emote ? this.emote.toJSON() : <any>undefined;
        data["commentId"] = this.commentId;
        return data;
    }
}

export interface IAddEmoteDto {
    emote?: EmoteDto | undefined;
    commentId?: string | undefined;
}

/** Runtime feature flags returned to the client. */
export class FeatureFlagsDto implements IFeatureFlagsDto {
    enableNewTicketFlow?: boolean;

    constructor(data?: IFeatureFlagsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableNewTicketFlow = _data["enableNewTicketFlow"];
        }
    }

    static fromJS(data: any): FeatureFlagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureFlagsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableNewTicketFlow"] = this.enableNewTicketFlow;
        return data;
    }
}

/** Runtime feature flags returned to the client. */
export interface IFeatureFlagsDto {
    enableNewTicketFlow?: boolean;
}

export class BlobAttachmentDto implements IBlobAttachmentDto {
    fullBlobUri?: string | undefined;
    blobUri?: string | undefined;
    blobSasUri?: string | undefined;
    response?: BlobContentInfo | undefined;

    constructor(data?: IBlobAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullBlobUri = _data["fullBlobUri"];
            this.blobUri = _data["blobUri"];
            this.blobSasUri = _data["blobSasUri"];
            this.response = _data["response"] ? BlobContentInfo.fromJS(_data["response"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BlobAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlobAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullBlobUri"] = this.fullBlobUri;
        data["blobUri"] = this.blobUri;
        data["blobSasUri"] = this.blobSasUri;
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBlobAttachmentDto {
    fullBlobUri?: string | undefined;
    blobUri?: string | undefined;
    blobSasUri?: string | undefined;
    response?: BlobContentInfo | undefined;
}

/** BlobContentInfo */
export class BlobContentInfo implements IBlobContentInfo {
    /** The ETag contains a value that you can use to perform operations conditionally. If the request version is 2011-08-18 or newer, the ETag value will be in quotes. */
    eTag?: ETag;
    /** Returns the date and time the container was last modified. Any operation that modifies the blob, including an update of the blob's metadata or properties, changes the last-modified time of the blob. */
    lastModified?: Date;
    /** If the blob has an MD5 hash and this operation is to read the full blob, this response header is returned so that the client can check for message content integrity. */
    contentHash?: string | undefined;
    /** A DateTime value returned by the service that uniquely identifies the blob. The value of this header indicates the blob version, and may be used in subsequent requests to access this version of the blob. */
    versionId?: string | undefined;
    /** The SHA-256 hash of the encryption key used to encrypt the blob. This header is only returned when the blob was encrypted with a customer-provided key. */
    encryptionKeySha256?: string | undefined;
    /** Returns the name of the encryption scope used to encrypt the blob contents and application metadata.  Note that the absence of this header implies use of the default account encryption scope. */
    encryptionScope?: string | undefined;
    /** The current sequence number for the page blob.  This is only returned for page blobs. */
    blobSequenceNumber?: number;

    constructor(data?: IBlobContentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eTag = _data["eTag"] ? ETag.fromJS(_data["eTag"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.contentHash = _data["contentHash"];
            this.versionId = _data["versionId"];
            this.encryptionKeySha256 = _data["encryptionKeySha256"];
            this.encryptionScope = _data["encryptionScope"];
            this.blobSequenceNumber = _data["blobSequenceNumber"];
        }
    }

    static fromJS(data: any): BlobContentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BlobContentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eTag"] = this.eTag ? this.eTag.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["contentHash"] = this.contentHash;
        data["versionId"] = this.versionId;
        data["encryptionKeySha256"] = this.encryptionKeySha256;
        data["encryptionScope"] = this.encryptionScope;
        data["blobSequenceNumber"] = this.blobSequenceNumber;
        return data;
    }
}

/** BlobContentInfo */
export interface IBlobContentInfo {
    /** The ETag contains a value that you can use to perform operations conditionally. If the request version is 2011-08-18 or newer, the ETag value will be in quotes. */
    eTag?: ETag;
    /** Returns the date and time the container was last modified. Any operation that modifies the blob, including an update of the blob's metadata or properties, changes the last-modified time of the blob. */
    lastModified?: Date;
    /** If the blob has an MD5 hash and this operation is to read the full blob, this response header is returned so that the client can check for message content integrity. */
    contentHash?: string | undefined;
    /** A DateTime value returned by the service that uniquely identifies the blob. The value of this header indicates the blob version, and may be used in subsequent requests to access this version of the blob. */
    versionId?: string | undefined;
    /** The SHA-256 hash of the encryption key used to encrypt the blob. This header is only returned when the blob was encrypted with a customer-provided key. */
    encryptionKeySha256?: string | undefined;
    /** Returns the name of the encryption scope used to encrypt the blob contents and application metadata.  Note that the absence of this header implies use of the default account encryption scope. */
    encryptionScope?: string | undefined;
    /** The current sequence number for the page blob.  This is only returned for page blobs. */
    blobSequenceNumber?: number;
}

/** Represents an HTTP ETag. */
export class ETag implements IETag {

    constructor(data?: IETag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ETag {
        data = typeof data === 'object' ? data : {};
        let result = new ETag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Represents an HTTP ETag. */
export interface IETag {
}

export class CustomerFamilyOperationDto implements ICustomerFamilyOperationDto {
    submissionId?: string;
    generation?: number;
    sourceRequestId?: string | undefined;
    parentRequestId?: string | undefined;
    parentRequestDatabaseId?: string | undefined;
    parentStatus?: RequestStatus;
    parentCreated?: boolean;
    reservedParent?: CustomerFamilyReservationDto | undefined;
    reservedChildren?: CustomerFamilyReservationDto[] | undefined;
    completed?: boolean;
    result?: CustomerImpactResponseDto | undefined;

    constructor(data?: ICustomerFamilyOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.generation = _data["generation"];
            this.sourceRequestId = _data["sourceRequestId"];
            this.parentRequestId = _data["parentRequestId"];
            this.parentRequestDatabaseId = _data["parentRequestDatabaseId"];
            this.parentStatus = _data["parentStatus"];
            this.parentCreated = _data["parentCreated"];
            this.reservedParent = _data["reservedParent"] ? CustomerFamilyReservationDto.fromJS(_data["reservedParent"]) : <any>undefined;
            if (Array.isArray(_data["reservedChildren"])) {
                this.reservedChildren = [] as any;
                for (let item of _data["reservedChildren"])
                    this.reservedChildren!.push(CustomerFamilyReservationDto.fromJS(item));
            }
            this.completed = _data["completed"];
            this.result = _data["result"] ? CustomerImpactResponseDto.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerFamilyOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFamilyOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["generation"] = this.generation;
        data["sourceRequestId"] = this.sourceRequestId;
        data["parentRequestId"] = this.parentRequestId;
        data["parentRequestDatabaseId"] = this.parentRequestDatabaseId;
        data["parentStatus"] = this.parentStatus;
        data["parentCreated"] = this.parentCreated;
        data["reservedParent"] = this.reservedParent ? this.reservedParent.toJSON() : <any>undefined;
        if (Array.isArray(this.reservedChildren)) {
            data["reservedChildren"] = [];
            for (let item of this.reservedChildren)
                data["reservedChildren"].push(item ? item.toJSON() : <any>undefined);
        }
        data["completed"] = this.completed;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerFamilyOperationDto {
    submissionId?: string;
    generation?: number;
    sourceRequestId?: string | undefined;
    parentRequestId?: string | undefined;
    parentRequestDatabaseId?: string | undefined;
    parentStatus?: RequestStatus;
    parentCreated?: boolean;
    reservedParent?: CustomerFamilyReservationDto | undefined;
    reservedChildren?: CustomerFamilyReservationDto[] | undefined;
    completed?: boolean;
    result?: CustomerImpactResponseDto | undefined;
}

export enum RequestStatus {
    New = 1,
    Active = 2,
    InProgress = 3,
    Resolved = 4,
    Closed = 5,
}

export class CustomerFamilyReservationDto implements ICustomerFamilyReservationDto {
    databaseId?: string;
    requestId?: string | undefined;

    constructor(data?: ICustomerFamilyReservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.databaseId = _data["databaseId"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): CustomerFamilyReservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFamilyReservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["databaseId"] = this.databaseId;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface ICustomerFamilyReservationDto {
    databaseId?: string;
    requestId?: string | undefined;
}

export class CustomerImpactResponseDto implements ICustomerImpactResponseDto {
    id?: string | undefined;
    originalRequestId?: string | undefined;
    parentRequestId?: string | undefined;
    parentCreated?: boolean;
    outcomes?: CustomerImpactOutcomeDto[] | undefined;

    constructor(data?: ICustomerImpactResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalRequestId = _data["originalRequestId"];
            this.parentRequestId = _data["parentRequestId"];
            this.parentCreated = _data["parentCreated"];
            if (Array.isArray(_data["outcomes"])) {
                this.outcomes = [] as any;
                for (let item of _data["outcomes"])
                    this.outcomes!.push(CustomerImpactOutcomeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerImpactResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalRequestId"] = this.originalRequestId;
        data["parentRequestId"] = this.parentRequestId;
        data["parentCreated"] = this.parentCreated;
        if (Array.isArray(this.outcomes)) {
            data["outcomes"] = [];
            for (let item of this.outcomes)
                data["outcomes"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICustomerImpactResponseDto {
    id?: string | undefined;
    originalRequestId?: string | undefined;
    parentRequestId?: string | undefined;
    parentCreated?: boolean;
    outcomes?: CustomerImpactOutcomeDto[] | undefined;
}

export class CustomerImpactOutcomeDto implements ICustomerImpactOutcomeDto {
    customerName?: string | undefined;
    requestId?: string | undefined;
    action?: string | undefined;
    requestedResolutionDate?: Date | undefined;
    attachmentTarget?: string | undefined;

    constructor(data?: ICustomerImpactOutcomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.requestId = _data["requestId"];
            this.action = _data["action"];
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.attachmentTarget = _data["attachmentTarget"];
        }
    }

    static fromJS(data: any): CustomerImpactOutcomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactOutcomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["requestId"] = this.requestId;
        data["action"] = this.action;
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["attachmentTarget"] = this.attachmentTarget;
        return data;
    }
}

export interface ICustomerImpactOutcomeDto {
    customerName?: string | undefined;
    requestId?: string | undefined;
    action?: string | undefined;
    requestedResolutionDate?: Date | undefined;
    attachmentTarget?: string | undefined;
}

export class CustomerFamilyOperationRequestDto implements ICustomerFamilyOperationRequestDto {
    submissionId?: string;
    sourceRequestId?: string | undefined;
    payloadHash?: string | undefined;
    childCount?: number;

    constructor(data?: ICustomerFamilyOperationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.sourceRequestId = _data["sourceRequestId"];
            this.payloadHash = _data["payloadHash"];
            this.childCount = _data["childCount"];
        }
    }

    static fromJS(data: any): CustomerFamilyOperationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFamilyOperationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["sourceRequestId"] = this.sourceRequestId;
        data["payloadHash"] = this.payloadHash;
        data["childCount"] = this.childCount;
        return data;
    }
}

export interface ICustomerFamilyOperationRequestDto {
    submissionId?: string;
    sourceRequestId?: string | undefined;
    payloadHash?: string | undefined;
    childCount?: number;
}

export class CompleteCustomerFamilyOperationDto implements ICompleteCustomerFamilyOperationDto {
    submissionId?: string;
    result?: CustomerImpactResponseDto | undefined;

    constructor(data?: ICompleteCustomerFamilyOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.result = _data["result"] ? CustomerImpactResponseDto.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompleteCustomerFamilyOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteCustomerFamilyOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompleteCustomerFamilyOperationDto {
    submissionId?: string;
    result?: CustomerImpactResponseDto | undefined;
}

export class BaseRequestDto implements IBaseRequestDto {
    id?: string;
    whyThisDateIsImportant?: string | undefined;
    unifiedTrackingId?: string | undefined;
    status?: RequestStatus;
    requestedResolutionDate?: Date | undefined;
    actualResolutionDate?: Date | undefined;
    closedOn?: Date | undefined;
    description?: string | undefined;
    confidentialIdentifier?: string | undefined;
    escalationReason?: string | undefined;
    warrantyHelpType?: string | undefined;
    warrantyAdditionalDetails?: string | undefined;
    businessConsequence?: string | undefined;
    customersPayMore?: string | undefined;
    estimatedPriceUplift?: string | undefined;
    keyCompetitors?: string | undefined;
    feedbackSource?: string | undefined;
    feedbackSourceDetails?: string | undefined;
    submittedViaNewFlow?: boolean;
    customerFamilySubmissionId?: string | undefined;
    customerFamilyGeneration?: number | undefined;
    attachments?: AttachmentDto[] | undefined;
    customerImpacts?: CustomerImpactDto[] | undefined;
    watchers?: UserDto[] | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;
    totalDeviceCount?: number;
    totalRevenue?: number;
    msxTotalRevenue?: number;
    msxTotalDeviceCount?: number;
    msxCurrentTotalRevenue?: number;
    msxCurrentTotalDeviceCount?: number;
    reasonForReassignment?: number | undefined;
    assignee?: UserDto | undefined;
    companyInformation?: CompanyInformationDto | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    hashTags?: HashTagDto[] | undefined;
    isParent?: boolean | undefined;
    childrenCount?: number | undefined;
    parentRequestId?: string | undefined;
    parentRequestDatabaseId?: string | undefined;
    originalRoutingML?: boolean | undefined;
    isActive?: boolean;

    constructor(data?: IBaseRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.whyThisDateIsImportant = _data["whyThisDateIsImportant"];
            this.unifiedTrackingId = _data["unifiedTrackingId"];
            this.status = _data["status"];
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.actualResolutionDate = _data["actualResolutionDate"] ? new Date(_data["actualResolutionDate"].toString()) : <any>undefined;
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.confidentialIdentifier = _data["confidentialIdentifier"];
            this.escalationReason = _data["escalationReason"];
            this.warrantyHelpType = _data["warrantyHelpType"];
            this.warrantyAdditionalDetails = _data["warrantyAdditionalDetails"];
            this.businessConsequence = _data["businessConsequence"];
            this.customersPayMore = _data["customersPayMore"];
            this.estimatedPriceUplift = _data["estimatedPriceUplift"];
            this.keyCompetitors = _data["keyCompetitors"];
            this.feedbackSource = _data["feedbackSource"];
            this.feedbackSourceDetails = _data["feedbackSourceDetails"];
            this.submittedViaNewFlow = _data["submittedViaNewFlow"];
            this.customerFamilySubmissionId = _data["customerFamilySubmissionId"];
            this.customerFamilyGeneration = _data["customerFamilyGeneration"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["customerImpacts"])) {
                this.customerImpacts = [] as any;
                for (let item of _data["customerImpacts"])
                    this.customerImpacts!.push(CustomerImpactDto.fromJS(item));
            }
            if (Array.isArray(_data["watchers"])) {
                this.watchers = [] as any;
                for (let item of _data["watchers"])
                    this.watchers!.push(UserDto.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"] ? UserDto.fromJS(_data["modifiedBy"]) : <any>undefined;
            this.totalDeviceCount = _data["totalDeviceCount"];
            this.totalRevenue = _data["totalRevenue"];
            this.msxTotalRevenue = _data["msxTotalRevenue"];
            this.msxTotalDeviceCount = _data["msxTotalDeviceCount"];
            this.msxCurrentTotalRevenue = _data["msxCurrentTotalRevenue"];
            this.msxCurrentTotalDeviceCount = _data["msxCurrentTotalDeviceCount"];
            this.reasonForReassignment = _data["reasonForReassignment"];
            this.assignee = _data["assignee"] ? UserDto.fromJS(_data["assignee"]) : <any>undefined;
            this.companyInformation = _data["companyInformation"] ? CompanyInformationDto.fromJS(_data["companyInformation"]) : <any>undefined;
            if (Array.isArray(_data["deviceModels"])) {
                this.deviceModels = [] as any;
                for (let item of _data["deviceModels"])
                    this.deviceModels!.push(DeviceModelDto.fromJS(item));
            }
            if (Array.isArray(_data["hashTags"])) {
                this.hashTags = [] as any;
                for (let item of _data["hashTags"])
                    this.hashTags!.push(HashTagDto.fromJS(item));
            }
            this.isParent = _data["isParent"];
            this.childrenCount = _data["childrenCount"];
            this.parentRequestId = _data["parentRequestId"];
            this.parentRequestDatabaseId = _data["parentRequestDatabaseId"];
            this.originalRoutingML = _data["originalRoutingML"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BaseRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["whyThisDateIsImportant"] = this.whyThisDateIsImportant;
        data["unifiedTrackingId"] = this.unifiedTrackingId;
        data["status"] = this.status;
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["actualResolutionDate"] = this.actualResolutionDate ? this.actualResolutionDate.toISOString() : <any>undefined;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["confidentialIdentifier"] = this.confidentialIdentifier;
        data["escalationReason"] = this.escalationReason;
        data["warrantyHelpType"] = this.warrantyHelpType;
        data["warrantyAdditionalDetails"] = this.warrantyAdditionalDetails;
        data["businessConsequence"] = this.businessConsequence;
        data["customersPayMore"] = this.customersPayMore;
        data["estimatedPriceUplift"] = this.estimatedPriceUplift;
        data["keyCompetitors"] = this.keyCompetitors;
        data["feedbackSource"] = this.feedbackSource;
        data["feedbackSourceDetails"] = this.feedbackSourceDetails;
        data["submittedViaNewFlow"] = this.submittedViaNewFlow;
        data["customerFamilySubmissionId"] = this.customerFamilySubmissionId;
        data["customerFamilyGeneration"] = this.customerFamilyGeneration;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.customerImpacts)) {
            data["customerImpacts"] = [];
            for (let item of this.customerImpacts)
                data["customerImpacts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.watchers)) {
            data["watchers"] = [];
            for (let item of this.watchers)
                data["watchers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        data["totalDeviceCount"] = this.totalDeviceCount;
        data["totalRevenue"] = this.totalRevenue;
        data["msxTotalRevenue"] = this.msxTotalRevenue;
        data["msxTotalDeviceCount"] = this.msxTotalDeviceCount;
        data["msxCurrentTotalRevenue"] = this.msxCurrentTotalRevenue;
        data["msxCurrentTotalDeviceCount"] = this.msxCurrentTotalDeviceCount;
        data["reasonForReassignment"] = this.reasonForReassignment;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["companyInformation"] = this.companyInformation ? this.companyInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceModels)) {
            data["deviceModels"] = [];
            for (let item of this.deviceModels)
                data["deviceModels"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.hashTags)) {
            data["hashTags"] = [];
            for (let item of this.hashTags)
                data["hashTags"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isParent"] = this.isParent;
        data["childrenCount"] = this.childrenCount;
        data["parentRequestId"] = this.parentRequestId;
        data["parentRequestDatabaseId"] = this.parentRequestDatabaseId;
        data["originalRoutingML"] = this.originalRoutingML;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBaseRequestDto {
    id?: string;
    whyThisDateIsImportant?: string | undefined;
    unifiedTrackingId?: string | undefined;
    status?: RequestStatus;
    requestedResolutionDate?: Date | undefined;
    actualResolutionDate?: Date | undefined;
    closedOn?: Date | undefined;
    description?: string | undefined;
    confidentialIdentifier?: string | undefined;
    escalationReason?: string | undefined;
    warrantyHelpType?: string | undefined;
    warrantyAdditionalDetails?: string | undefined;
    businessConsequence?: string | undefined;
    customersPayMore?: string | undefined;
    estimatedPriceUplift?: string | undefined;
    keyCompetitors?: string | undefined;
    feedbackSource?: string | undefined;
    feedbackSourceDetails?: string | undefined;
    submittedViaNewFlow?: boolean;
    customerFamilySubmissionId?: string | undefined;
    customerFamilyGeneration?: number | undefined;
    attachments?: AttachmentDto[] | undefined;
    customerImpacts?: CustomerImpactDto[] | undefined;
    watchers?: UserDto[] | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;
    totalDeviceCount?: number;
    totalRevenue?: number;
    msxTotalRevenue?: number;
    msxTotalDeviceCount?: number;
    msxCurrentTotalRevenue?: number;
    msxCurrentTotalDeviceCount?: number;
    reasonForReassignment?: number | undefined;
    assignee?: UserDto | undefined;
    companyInformation?: CompanyInformationDto | undefined;
    deviceModels?: DeviceModelDto[] | undefined;
    hashTags?: HashTagDto[] | undefined;
    isParent?: boolean | undefined;
    childrenCount?: number | undefined;
    parentRequestId?: string | undefined;
    parentRequestDatabaseId?: string | undefined;
    originalRoutingML?: boolean | undefined;
    isActive?: boolean;
}

export class RequestDto extends BaseRequestDto implements IRequestDto {
    summary?: string | undefined;
    isHidden?: boolean;
    requestType?: RequestType;
    requestTeam?: RequestDomain;
    customerType?: CrewCustomerType | undefined;
    actionRequired?: string | undefined;
    additionalContact?: AdditionalContactDto | undefined;
    requestActionTakenByCss?: string | undefined;
    isDcfRequest?: boolean | undefined;
    dcfJustification?: string | undefined;
    dealInfluenced?: boolean | undefined;
    closingSummary?: string | undefined;
    cssCaseNumber?: string | undefined;
    proofOfPurchaseAttached?: boolean | undefined;
    serialNumbersAttached?: boolean | undefined;
    isBookmarked?: boolean;
    priorityNumber?: number | undefined;
    criticality?: Criticality | undefined;
    impactReach?: ImpactReach | undefined;
    productCategory?: ProductCategory | undefined;
    approvedMessaging?: string | undefined;
    whatBusinessProblemIsSolved?: string | undefined;
    competitiveOffering?: string | undefined;
    isDesignForSurfacedPossible?: string | undefined;
    pfrSubType?: PFRSubtype | undefined;
    bugInformations?: BugInformations[] | undefined;
    bugNumber?: string | undefined;
    priority?: Priority | undefined;
    caseCodeInvestigation?: CaseCodeInvestigation | undefined;
    caseCodeRequest?: CaseCodeRequest | undefined;
    mainRequestType?: MainRequestType | undefined;
    subRequestType?: SubRequestType | undefined;
    isBlockingSale?: boolean | undefined;
    isDcfApproved?: boolean | undefined;
    dcfApprovedValue?: number | undefined;
    dcfSR?: string | undefined;
    answer?: string | undefined;
    backendId?: string | undefined;
    backendUrl?: string | undefined;
    taskStatus?: TaskStatus | undefined;
    tags?: TagDto[] | undefined;
    selected?: any | undefined;

    constructor(data?: IRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summary = _data["summary"];
            this.isHidden = _data["isHidden"];
            this.requestType = _data["requestType"];
            this.requestTeam = _data["requestTeam"];
            this.customerType = _data["customerType"];
            this.actionRequired = _data["actionRequired"];
            this.additionalContact = _data["additionalContact"] ? AdditionalContactDto.fromJS(_data["additionalContact"]) : <any>undefined;
            this.requestActionTakenByCss = _data["requestActionTakenByCss"];
            this.isDcfRequest = _data["isDcfRequest"];
            this.dcfJustification = _data["dcfJustification"];
            this.dealInfluenced = _data["dealInfluenced"];
            this.closingSummary = _data["closingSummary"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.proofOfPurchaseAttached = _data["proofOfPurchaseAttached"];
            this.serialNumbersAttached = _data["serialNumbersAttached"];
            this.isBookmarked = _data["isBookmarked"];
            this.priorityNumber = _data["priorityNumber"];
            this.criticality = _data["criticality"];
            this.impactReach = _data["impactReach"];
            this.productCategory = _data["productCategory"];
            this.approvedMessaging = _data["approvedMessaging"];
            this.whatBusinessProblemIsSolved = _data["whatBusinessProblemIsSolved"];
            this.competitiveOffering = _data["competitiveOffering"];
            this.isDesignForSurfacedPossible = _data["isDesignForSurfacedPossible"];
            this.pfrSubType = _data["pfrSubType"];
            if (Array.isArray(_data["bugInformations"])) {
                this.bugInformations = [] as any;
                for (let item of _data["bugInformations"])
                    this.bugInformations!.push(BugInformations.fromJS(item));
            }
            this.bugNumber = _data["bugNumber"];
            this.priority = _data["priority"];
            this.caseCodeInvestigation = _data["caseCodeInvestigation"];
            this.caseCodeRequest = _data["caseCodeRequest"];
            this.mainRequestType = _data["mainRequestType"];
            this.subRequestType = _data["subRequestType"];
            this.isBlockingSale = _data["isBlockingSale"];
            this.isDcfApproved = _data["isDcfApproved"];
            this.dcfApprovedValue = _data["dcfApprovedValue"];
            this.dcfSR = _data["dcfSR"];
            this.answer = _data["answer"];
            this.backendId = _data["backendId"];
            this.backendUrl = _data["backendUrl"];
            this.taskStatus = _data["taskStatus"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.selected = _data["selected"];
        }
    }

    static override fromJS(data: any): RequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        data["isHidden"] = this.isHidden;
        data["requestType"] = this.requestType;
        data["requestTeam"] = this.requestTeam;
        data["customerType"] = this.customerType;
        data["actionRequired"] = this.actionRequired;
        data["additionalContact"] = this.additionalContact ? this.additionalContact.toJSON() : <any>undefined;
        data["requestActionTakenByCss"] = this.requestActionTakenByCss;
        data["isDcfRequest"] = this.isDcfRequest;
        data["dcfJustification"] = this.dcfJustification;
        data["dealInfluenced"] = this.dealInfluenced;
        data["closingSummary"] = this.closingSummary;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["proofOfPurchaseAttached"] = this.proofOfPurchaseAttached;
        data["serialNumbersAttached"] = this.serialNumbersAttached;
        data["isBookmarked"] = this.isBookmarked;
        data["priorityNumber"] = this.priorityNumber;
        data["criticality"] = this.criticality;
        data["impactReach"] = this.impactReach;
        data["productCategory"] = this.productCategory;
        data["approvedMessaging"] = this.approvedMessaging;
        data["whatBusinessProblemIsSolved"] = this.whatBusinessProblemIsSolved;
        data["competitiveOffering"] = this.competitiveOffering;
        data["isDesignForSurfacedPossible"] = this.isDesignForSurfacedPossible;
        data["pfrSubType"] = this.pfrSubType;
        if (Array.isArray(this.bugInformations)) {
            data["bugInformations"] = [];
            for (let item of this.bugInformations)
                data["bugInformations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["bugNumber"] = this.bugNumber;
        data["priority"] = this.priority;
        data["caseCodeInvestigation"] = this.caseCodeInvestigation;
        data["caseCodeRequest"] = this.caseCodeRequest;
        data["mainRequestType"] = this.mainRequestType;
        data["subRequestType"] = this.subRequestType;
        data["isBlockingSale"] = this.isBlockingSale;
        data["isDcfApproved"] = this.isDcfApproved;
        data["dcfApprovedValue"] = this.dcfApprovedValue;
        data["dcfSR"] = this.dcfSR;
        data["answer"] = this.answer;
        data["backendId"] = this.backendId;
        data["backendUrl"] = this.backendUrl;
        data["taskStatus"] = this.taskStatus;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>undefined);
        }
        data["selected"] = this.selected;
        super.toJSON(data);
        return data;
    }
}

export interface IRequestDto extends IBaseRequestDto {
    summary?: string | undefined;
    isHidden?: boolean;
    requestType?: RequestType;
    requestTeam?: RequestDomain;
    customerType?: CrewCustomerType | undefined;
    actionRequired?: string | undefined;
    additionalContact?: AdditionalContactDto | undefined;
    requestActionTakenByCss?: string | undefined;
    isDcfRequest?: boolean | undefined;
    dcfJustification?: string | undefined;
    dealInfluenced?: boolean | undefined;
    closingSummary?: string | undefined;
    cssCaseNumber?: string | undefined;
    proofOfPurchaseAttached?: boolean | undefined;
    serialNumbersAttached?: boolean | undefined;
    isBookmarked?: boolean;
    priorityNumber?: number | undefined;
    criticality?: Criticality | undefined;
    impactReach?: ImpactReach | undefined;
    productCategory?: ProductCategory | undefined;
    approvedMessaging?: string | undefined;
    whatBusinessProblemIsSolved?: string | undefined;
    competitiveOffering?: string | undefined;
    isDesignForSurfacedPossible?: string | undefined;
    pfrSubType?: PFRSubtype | undefined;
    bugInformations?: BugInformations[] | undefined;
    bugNumber?: string | undefined;
    priority?: Priority | undefined;
    caseCodeInvestigation?: CaseCodeInvestigation | undefined;
    caseCodeRequest?: CaseCodeRequest | undefined;
    mainRequestType?: MainRequestType | undefined;
    subRequestType?: SubRequestType | undefined;
    isBlockingSale?: boolean | undefined;
    isDcfApproved?: boolean | undefined;
    dcfApprovedValue?: number | undefined;
    dcfSR?: string | undefined;
    answer?: string | undefined;
    backendId?: string | undefined;
    backendUrl?: string | undefined;
    taskStatus?: TaskStatus | undefined;
    tags?: TagDto[] | undefined;
    selected?: any | undefined;
}

export enum CrewCustomerType {
    Business_Enterprise_Customer = 1,
    EDU_Customer = 2,
    GOV_Customer = 3,
}

export class AdditionalContactDto implements IAdditionalContactDto {
    additionalShippingAddress?: string | undefined;
    additionalEmailAddress?: string | undefined;
    additionalPhoneNumber?: string | undefined;

    constructor(data?: IAdditionalContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalShippingAddress = _data["additionalShippingAddress"];
            this.additionalEmailAddress = _data["additionalEmailAddress"];
            this.additionalPhoneNumber = _data["additionalPhoneNumber"];
        }
    }

    static fromJS(data: any): AdditionalContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalShippingAddress"] = this.additionalShippingAddress;
        data["additionalEmailAddress"] = this.additionalEmailAddress;
        data["additionalPhoneNumber"] = this.additionalPhoneNumber;
        return data;
    }
}

export interface IAdditionalContactDto {
    additionalShippingAddress?: string | undefined;
    additionalEmailAddress?: string | undefined;
    additionalPhoneNumber?: string | undefined;
}

export enum Criticality {
    Zero = 1,
    Fifty = 2,
    OneHundred = 3,
    TwoHundred = 4,
}

export enum ImpactReach {
    Exec_CAB = 1,
    Global = 2,
    No = 3,
}

export enum ProductCategory {
    Hardware = 1,
    Software = 2,
    Other = 3,
    Expirience = 4,
    Policy = 5,
    Warranty = 6,
    ProductFamily = 7,
}

export enum PFRSubtype {
    Emerging_PFR = 1,
    Priority_PFR = 2,
}

export class BugInformations implements IBugInformations {
    bugInformation?: BugInformation;
    url?: string | undefined;

    constructor(data?: IBugInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bugInformation = _data["bugInformation"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): BugInformations {
        data = typeof data === 'object' ? data : {};
        let result = new BugInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bugInformation"] = this.bugInformation;
        data["url"] = this.url;
        return data;
    }
}

export interface IBugInformations {
    bugInformation?: BugInformation;
    url?: string | undefined;
}

export enum BugInformation {
    PLE_Bug = 1,
    MSFT_Devices_Non_PLE_Bug = 2,
    OS_Bug = 3,
    Hub_OS_Bug = 4,
    Other_Bugs = 5,
    Azure_Devops_Link = 6,
}

export enum Priority {
    High = 1,
    Medium = 2,
    Low = 3,
}

export enum CaseCodeInvestigation {
    CoverageDetails = 1,
    FeedbackSuggestion = 2,
    Operational_SLA = 3,
    Process_Or_PolicyFailure_Limitation = 4,
    Proper_Process_Not_Followed = 5,
    ReverseLogistics = 6,
    RRT_Scenario = 7,
    Surface_Help_Request = 8,
}

export enum CaseCodeRequest {
    FortyFiveDayException = 1,
    ASKU = 2,
    BulkOrder_Or_Exchange = 3,
    DOA_Exception = 4,
    DocumentationRequest = 5,
    GeneralException = 6,
    InvoiceDispute = 7,
    Missing_ADP_Or_EHS = 8,
    NotAvailable = 9,
    Other = 10,
    ProductQuality_Or_PLE = 11,
    ScreenFlicker = 12,
    SwollenBattery = 13,
    WA_Date_Correction = 14,
    WA_Deployment_Date_Adjustment = 15,
    WarrantyReport = 16,
    WrongAutoPilot_Or_InTuneRegistration = 17,
    ExchangeHistory = 18,
}

export enum MainRequestType {
    Exceptions = 1,
    Experience_Or_Offers = 2,
    Reporting = 3,
    Process_Or_PolicyFailure = 4,
    Process_Not_Followed = 5,
    Other = 6,
}

export enum SubRequestType {
    FortyFiveDayException = 1,
    ASKURequest = 2,
    BulkOrder_Or_ExchangeRequest = 3,
    BulkShipping_Or_PickUp = 4,
    OutOfWarranty = 5,
    SwollenBattery = 6,
    DCFGeneralRequest = 7,
    WA_DeploymentDateRequest = 8,
    EPP_PricingChange = 9,
    New_EPP_OfferType = 10,
    NewSupportExperiences = 11,
    OfferExpansion_NewMarket = 12,
    ExchangeHistory = 13,
    WarrantyStatusReport = 14,
    InvoiceDispute = 15,
    Missing_EPP_AfterExchange = 16,
    MissingShippingLabel = 17,
    WA_DateCorrection = 18,
    EPP_didnot_attach_via_MSOnline = 19,
    EPP_didnot_attach_via_MSBnM = 20,
    WA_DateDelay = 21,
    EPP_didnot_attach_OtherRetailer = 22,
    Partner_Didnot_Register = 23,
    ReturnWrongUnit = 24,
    Unit_Not_Returned = 25,
    Other = 26,
}

export enum TaskStatus {
    Consumer = 1,
    Duplicate = 2,
    Following_Or_NoAction = 3,
    FrontlineSupport = 4,
    FrontlineSupport_T2 = 5,
    InvalidRequest = 6,
    NonTechnical = 7,
    SEE_Takeover = 8,
}

export class TagDto implements ITagDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITagDto {
    id?: string;
    name?: string | undefined;
}

export class AttachmentDto implements IAttachmentDto {
    id?: string;
    url?: string | undefined;
    fileName?: string | undefined;
    blobFileName?: string | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    isExternal?: boolean;
    etag?: string | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.fileName = _data["fileName"];
            this.blobFileName = _data["blobFileName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.isExternal = _data["isExternal"];
            this.etag = _data["etag"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["fileName"] = this.fileName;
        data["blobFileName"] = this.blobFileName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["isExternal"] = this.isExternal;
        data["etag"] = this.etag;
        return data;
    }
}

export interface IAttachmentDto {
    id?: string;
    url?: string | undefined;
    fileName?: string | undefined;
    blobFileName?: string | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    isExternal?: boolean;
    etag?: string | undefined;
}

export class CustomerImpactDto implements ICustomerImpactDto {
    opportunityId?: string | undefined;
    tpId?: string | undefined;
    accountId?: string | undefined;
    customerName?: string | undefined;
    customerImpactDescription?: string | undefined;
    requestDescription?: string | undefined;
    cssCaseNumber?: string | undefined;
    isSameAsTicket?: boolean;
    customerCountry?: CountryDto | undefined;
    msxOpportunityId?: string | undefined;
    deviceCount?: number | undefined;
    revenue?: number | undefined;
    msxDeviceCount?: number;
    msxRevenue?: number;
    msxCurrentDeviceCount?: number | undefined;
    msxCurrentRevenue?: number | undefined;
    msxInfoUpdatedOn?: Date | undefined;
    addedOn?: Date;
    addedBy?: UserDto | undefined;
    editedOn?: Date | undefined;
    editedBy?: string | undefined;
    editId?: string | undefined;
    endCustomerSegment?: string | undefined;
    competitor?: string | undefined;
    salesPlay?: string | undefined;
    refreshYourDevice?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;

    constructor(data?: ICustomerImpactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data["opportunityId"];
            this.tpId = _data["tpId"];
            this.accountId = _data["accountId"];
            this.customerName = _data["customerName"];
            this.customerImpactDescription = _data["customerImpactDescription"];
            this.requestDescription = _data["requestDescription"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.isSameAsTicket = _data["isSameAsTicket"];
            this.customerCountry = _data["customerCountry"] ? CountryDto.fromJS(_data["customerCountry"]) : <any>undefined;
            this.msxOpportunityId = _data["msxOpportunityId"];
            this.deviceCount = _data["deviceCount"];
            this.revenue = _data["revenue"];
            this.msxDeviceCount = _data["msxDeviceCount"];
            this.msxRevenue = _data["msxRevenue"];
            this.msxCurrentDeviceCount = _data["msxCurrentDeviceCount"];
            this.msxCurrentRevenue = _data["msxCurrentRevenue"];
            this.msxInfoUpdatedOn = _data["msxInfoUpdatedOn"] ? new Date(_data["msxInfoUpdatedOn"].toString()) : <any>undefined;
            this.addedOn = _data["addedOn"] ? new Date(_data["addedOn"].toString()) : <any>undefined;
            this.addedBy = _data["addedBy"] ? UserDto.fromJS(_data["addedBy"]) : <any>undefined;
            this.editedOn = _data["editedOn"] ? new Date(_data["editedOn"].toString()) : <any>undefined;
            this.editedBy = _data["editedBy"];
            this.editId = _data["editId"];
            this.endCustomerSegment = _data["endCustomerSegment"];
            this.competitor = _data["competitor"];
            this.salesPlay = _data["salesPlay"];
            this.refreshYourDevice = _data["refreshYourDevice"];
            this.status = _data["status"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): CustomerImpactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityId"] = this.opportunityId;
        data["tpId"] = this.tpId;
        data["accountId"] = this.accountId;
        data["customerName"] = this.customerName;
        data["customerImpactDescription"] = this.customerImpactDescription;
        data["requestDescription"] = this.requestDescription;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["isSameAsTicket"] = this.isSameAsTicket;
        data["customerCountry"] = this.customerCountry ? this.customerCountry.toJSON() : <any>undefined;
        data["msxOpportunityId"] = this.msxOpportunityId;
        data["deviceCount"] = this.deviceCount;
        data["revenue"] = this.revenue;
        data["msxDeviceCount"] = this.msxDeviceCount;
        data["msxRevenue"] = this.msxRevenue;
        data["msxCurrentDeviceCount"] = this.msxCurrentDeviceCount;
        data["msxCurrentRevenue"] = this.msxCurrentRevenue;
        data["msxInfoUpdatedOn"] = this.msxInfoUpdatedOn ? this.msxInfoUpdatedOn.toISOString() : <any>undefined;
        data["addedOn"] = this.addedOn ? this.addedOn.toISOString() : <any>undefined;
        data["addedBy"] = this.addedBy ? this.addedBy.toJSON() : <any>undefined;
        data["editedOn"] = this.editedOn ? this.editedOn.toISOString() : <any>undefined;
        data["editedBy"] = this.editedBy;
        data["editId"] = this.editId;
        data["endCustomerSegment"] = this.endCustomerSegment;
        data["competitor"] = this.competitor;
        data["salesPlay"] = this.salesPlay;
        data["refreshYourDevice"] = this.refreshYourDevice;
        data["status"] = this.status;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

export interface ICustomerImpactDto {
    opportunityId?: string | undefined;
    tpId?: string | undefined;
    accountId?: string | undefined;
    customerName?: string | undefined;
    customerImpactDescription?: string | undefined;
    requestDescription?: string | undefined;
    cssCaseNumber?: string | undefined;
    isSameAsTicket?: boolean;
    customerCountry?: CountryDto | undefined;
    msxOpportunityId?: string | undefined;
    deviceCount?: number | undefined;
    revenue?: number | undefined;
    msxDeviceCount?: number;
    msxRevenue?: number;
    msxCurrentDeviceCount?: number | undefined;
    msxCurrentRevenue?: number | undefined;
    msxInfoUpdatedOn?: Date | undefined;
    addedOn?: Date;
    addedBy?: UserDto | undefined;
    editedOn?: Date | undefined;
    editedBy?: string | undefined;
    editId?: string | undefined;
    endCustomerSegment?: string | undefined;
    competitor?: string | undefined;
    salesPlay?: string | undefined;
    refreshYourDevice?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
}

export class CountryDto implements ICountryDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICountryDto {
    id?: number;
    name?: string | undefined;
}

export class CompanyInformationDto implements ICompanyInformationDto {
    companyRegion?: CompanyRegion;
    companyContactName?: string | undefined;
    companyFullShippingAddress?: string | undefined;
    companyName?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    country?: string | undefined;
    alternateContactNumber?: string | undefined;

    constructor(data?: ICompanyInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyRegion = _data["companyRegion"];
            this.companyContactName = _data["companyContactName"];
            this.companyFullShippingAddress = _data["companyFullShippingAddress"];
            this.companyName = _data["companyName"];
            this.contactEmailAddress = _data["contactEmailAddress"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.country = _data["country"];
            this.alternateContactNumber = _data["alternateContactNumber"];
        }
    }

    static fromJS(data: any): CompanyInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRegion"] = this.companyRegion;
        data["companyContactName"] = this.companyContactName;
        data["companyFullShippingAddress"] = this.companyFullShippingAddress;
        data["companyName"] = this.companyName;
        data["contactEmailAddress"] = this.contactEmailAddress;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["country"] = this.country;
        data["alternateContactNumber"] = this.alternateContactNumber;
        return data;
    }
}

export interface ICompanyInformationDto {
    companyRegion?: CompanyRegion;
    companyContactName?: string | undefined;
    companyFullShippingAddress?: string | undefined;
    companyName?: string | undefined;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: string | undefined;
    country?: string | undefined;
    alternateContactNumber?: string | undefined;
}

export enum CompanyRegion {
    AOC = 1,
    EMEA = 2,
    APAC = 3,
    LATAM = 4,
    Global = 5,
}

export class DeviceModelDto implements IDeviceModelDto {
    id?: number;
    name?: string | undefined;
    categoryId?: number;
    deviceCount?: number;
    count?: number | undefined;
    iconUrl?: string | undefined;
    isAdded?: boolean | undefined;

    constructor(data?: IDeviceModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.deviceCount = _data["deviceCount"];
            this.count = _data["count"];
            this.iconUrl = _data["iconUrl"];
            this.isAdded = _data["isAdded"];
        }
    }

    static fromJS(data: any): DeviceModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["deviceCount"] = this.deviceCount;
        data["count"] = this.count;
        data["iconUrl"] = this.iconUrl;
        data["isAdded"] = this.isAdded;
        return data;
    }
}

export interface IDeviceModelDto {
    id?: number;
    name?: string | undefined;
    categoryId?: number;
    deviceCount?: number;
    count?: number | undefined;
    iconUrl?: string | undefined;
    isAdded?: boolean | undefined;
}

export class HashTagDto implements IHashTagDto {
    hashTag?: string | undefined;

    constructor(data?: IHashTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hashTag = _data["hashTag"];
        }
    }

    static fromJS(data: any): HashTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new HashTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hashTag"] = this.hashTag;
        return data;
    }
}

export interface IHashTagDto {
    hashTag?: string | undefined;
}

export class UpdateRequestDto implements IUpdateRequestDto {
    requestAction?: RequestAction;
    requestDto?: RequestDto | undefined;
    blobName?: string | undefined;
    eventData?: string | undefined;

    constructor(data?: IUpdateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestAction = _data["requestAction"];
            this.requestDto = _data["requestDto"] ? RequestDto.fromJS(_data["requestDto"]) : <any>undefined;
            this.blobName = _data["blobName"];
            this.eventData = _data["eventData"];
        }
    }

    static fromJS(data: any): UpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestAction"] = this.requestAction;
        data["requestDto"] = this.requestDto ? this.requestDto.toJSON() : <any>undefined;
        data["blobName"] = this.blobName;
        data["eventData"] = this.eventData;
        return data;
    }
}

export interface IUpdateRequestDto {
    requestAction?: RequestAction;
    requestDto?: RequestDto | undefined;
    blobName?: string | undefined;
    eventData?: string | undefined;
}

export enum RequestAction {
    Create = 1,
    Update = 2,
    Delete = 3,
    Assigned = 4,
    AddCustomerImpact = 5,
    AddAttachment = 6,
    DeleteAttachment = 7,
    DeleteCustomerImpact = 8,
    CommentAdd = 9,
    UpdateWatcher = 10,
    MarkAsInProgress = 11,
    MarkAsResolved = 12,
    MarkAsClosed = 13,
    Reassigned = 14,
    TagsUpdated = 15,
    SubTypeChanged = 16,
    MarkAsNew = 17,
    Associate = 18,
    AssociateAsParent = 19,
    AssociateAsChild = 20,
    AssociateChildToParent = 21,
    UnassociateFromParent = 22,
    UnassociateChild = 23,
    Unassociate = 24,
    PriorityChanged = 25,
    UpdateAttachment = 26,
    Unassigned = 27,
}

export class PaginatedListOfRequestDto implements IPaginatedListOfRequestDto {
    items?: RequestDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RequestDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfRequestDto {
    items?: RequestDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class DashboardFilterDto implements IDashboardFilterDto {
    dateRange?: DateRangeDto | undefined;
    requestTeam?: RequestDomain[] | undefined;
    requestType?: RequestType[] | undefined;
    countryModel?: string[] | undefined;
    caseStatus?: RequestStatus[] | undefined;
    assignee?: string[] | undefined;
    deviceModel?: number[] | undefined;
    aging?: AgingDto[] | undefined;
    relationship?: AssociationType[] | undefined;
    filterByCurrentUser?: boolean;
    watchedByCurrentUser?: boolean;
    sortProperty?: string | undefined;
    sortDirection?: ListSortDirection;
    isClosedRequestExcluded?: boolean;
    pageNumber?: number;
    pageSize?: number;
    parentRequestId?: string | undefined;
    getHiddenRequests?: boolean;
    hideParentRequests?: boolean;
    showUnassignedRequests?: boolean;
    isDcfRequest?: boolean | undefined;
    requestId?: string[] | undefined;
    portal?: Portal;

    constructor(data?: IDashboardFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRange = _data["dateRange"] ? DateRangeDto.fromJS(_data["dateRange"]) : <any>undefined;
            if (Array.isArray(_data["requestTeam"])) {
                this.requestTeam = [] as any;
                for (let item of _data["requestTeam"])
                    this.requestTeam!.push(item);
            }
            if (Array.isArray(_data["requestType"])) {
                this.requestType = [] as any;
                for (let item of _data["requestType"])
                    this.requestType!.push(item);
            }
            if (Array.isArray(_data["countryModel"])) {
                this.countryModel = [] as any;
                for (let item of _data["countryModel"])
                    this.countryModel!.push(item);
            }
            if (Array.isArray(_data["caseStatus"])) {
                this.caseStatus = [] as any;
                for (let item of _data["caseStatus"])
                    this.caseStatus!.push(item);
            }
            if (Array.isArray(_data["assignee"])) {
                this.assignee = [] as any;
                for (let item of _data["assignee"])
                    this.assignee!.push(item);
            }
            if (Array.isArray(_data["deviceModel"])) {
                this.deviceModel = [] as any;
                for (let item of _data["deviceModel"])
                    this.deviceModel!.push(item);
            }
            if (Array.isArray(_data["aging"])) {
                this.aging = [] as any;
                for (let item of _data["aging"])
                    this.aging!.push(AgingDto.fromJS(item));
            }
            if (Array.isArray(_data["relationship"])) {
                this.relationship = [] as any;
                for (let item of _data["relationship"])
                    this.relationship!.push(item);
            }
            this.filterByCurrentUser = _data["filterByCurrentUser"];
            this.watchedByCurrentUser = _data["watchedByCurrentUser"];
            this.sortProperty = _data["sortProperty"];
            this.sortDirection = _data["sortDirection"];
            this.isClosedRequestExcluded = _data["isClosedRequestExcluded"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.parentRequestId = _data["parentRequestId"];
            this.getHiddenRequests = _data["getHiddenRequests"];
            this.hideParentRequests = _data["hideParentRequests"];
            this.showUnassignedRequests = _data["showUnassignedRequests"];
            this.isDcfRequest = _data["isDcfRequest"];
            if (Array.isArray(_data["requestId"])) {
                this.requestId = [] as any;
                for (let item of _data["requestId"])
                    this.requestId!.push(item);
            }
            this.portal = _data["portal"];
        }
    }

    static fromJS(data: any): DashboardFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : <any>undefined;
        if (Array.isArray(this.requestTeam)) {
            data["requestTeam"] = [];
            for (let item of this.requestTeam)
                data["requestTeam"].push(item);
        }
        if (Array.isArray(this.requestType)) {
            data["requestType"] = [];
            for (let item of this.requestType)
                data["requestType"].push(item);
        }
        if (Array.isArray(this.countryModel)) {
            data["countryModel"] = [];
            for (let item of this.countryModel)
                data["countryModel"].push(item);
        }
        if (Array.isArray(this.caseStatus)) {
            data["caseStatus"] = [];
            for (let item of this.caseStatus)
                data["caseStatus"].push(item);
        }
        if (Array.isArray(this.assignee)) {
            data["assignee"] = [];
            for (let item of this.assignee)
                data["assignee"].push(item);
        }
        if (Array.isArray(this.deviceModel)) {
            data["deviceModel"] = [];
            for (let item of this.deviceModel)
                data["deviceModel"].push(item);
        }
        if (Array.isArray(this.aging)) {
            data["aging"] = [];
            for (let item of this.aging)
                data["aging"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.relationship)) {
            data["relationship"] = [];
            for (let item of this.relationship)
                data["relationship"].push(item);
        }
        data["filterByCurrentUser"] = this.filterByCurrentUser;
        data["watchedByCurrentUser"] = this.watchedByCurrentUser;
        data["sortProperty"] = this.sortProperty;
        data["sortDirection"] = this.sortDirection;
        data["isClosedRequestExcluded"] = this.isClosedRequestExcluded;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["parentRequestId"] = this.parentRequestId;
        data["getHiddenRequests"] = this.getHiddenRequests;
        data["hideParentRequests"] = this.hideParentRequests;
        data["showUnassignedRequests"] = this.showUnassignedRequests;
        data["isDcfRequest"] = this.isDcfRequest;
        if (Array.isArray(this.requestId)) {
            data["requestId"] = [];
            for (let item of this.requestId)
                data["requestId"].push(item);
        }
        data["portal"] = this.portal;
        return data;
    }
}

export interface IDashboardFilterDto {
    dateRange?: DateRangeDto | undefined;
    requestTeam?: RequestDomain[] | undefined;
    requestType?: RequestType[] | undefined;
    countryModel?: string[] | undefined;
    caseStatus?: RequestStatus[] | undefined;
    assignee?: string[] | undefined;
    deviceModel?: number[] | undefined;
    aging?: AgingDto[] | undefined;
    relationship?: AssociationType[] | undefined;
    filterByCurrentUser?: boolean;
    watchedByCurrentUser?: boolean;
    sortProperty?: string | undefined;
    sortDirection?: ListSortDirection;
    isClosedRequestExcluded?: boolean;
    pageNumber?: number;
    pageSize?: number;
    parentRequestId?: string | undefined;
    getHiddenRequests?: boolean;
    hideParentRequests?: boolean;
    showUnassignedRequests?: boolean;
    isDcfRequest?: boolean | undefined;
    requestId?: string[] | undefined;
    portal?: Portal;
}

export class DateRangeDto implements IDateRangeDto {
    from?: Date | undefined;
    to?: Date | undefined;

    constructor(data?: IDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDateRangeDto {
    from?: Date | undefined;
    to?: Date | undefined;
}

export class AgingDto implements IAgingDto {
    start?: Date;
    end?: Date;

    constructor(data?: IAgingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAgingDto {
    start?: Date;
    end?: Date;
}

export enum AssociationType {
    Parent = 1,
    Child = 2,
    None = 3,
}

export enum Portal {
    User = 1,
    Admin = 2,
}

export class ListBuilderFilter implements IListBuilderFilter {
    pageNumber?: number;
    filter?: RequestListBuilderFilter | undefined;

    constructor(data?: IListBuilderFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.filter = _data["filter"] ? RequestListBuilderFilter.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListBuilderFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListBuilderFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListBuilderFilter {
    pageNumber?: number;
    filter?: RequestListBuilderFilter | undefined;
}

export class RequestListBuilderFilter implements IRequestListBuilderFilter {
    teamFilters?: TeamFilter | undefined;
    propertyFilters?: PropertyFilter[] | undefined;

    constructor(data?: IRequestListBuilderFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamFilters = _data["teamFilters"] ? TeamFilter.fromJS(_data["teamFilters"]) : <any>undefined;
            if (Array.isArray(_data["propertyFilters"])) {
                this.propertyFilters = [] as any;
                for (let item of _data["propertyFilters"])
                    this.propertyFilters!.push(PropertyFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestListBuilderFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RequestListBuilderFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamFilters"] = this.teamFilters ? this.teamFilters.toJSON() : <any>undefined;
        if (Array.isArray(this.propertyFilters)) {
            data["propertyFilters"] = [];
            for (let item of this.propertyFilters)
                data["propertyFilters"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRequestListBuilderFilter {
    teamFilters?: TeamFilter | undefined;
    propertyFilters?: PropertyFilter[] | undefined;
}

export class TeamFilter implements ITeamFilter {
    requestTypes?: RequestType[] | undefined;

    constructor(data?: ITeamFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requestTypes"])) {
                this.requestTypes = [] as any;
                for (let item of _data["requestTypes"])
                    this.requestTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): TeamFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TeamFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requestTypes)) {
            data["requestTypes"] = [];
            for (let item of this.requestTypes)
                data["requestTypes"].push(item);
        }
        return data;
    }
}

export interface ITeamFilter {
    requestTypes?: RequestType[] | undefined;
}

export class PropertyFilter implements IPropertyFilter {
    condition?: Conditions;
    operator?: string | undefined;
    filter?: ListBuilderFilter2 | undefined;

    constructor(data?: IPropertyFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.condition = _data["condition"];
            this.operator = _data["operator"];
            this.filter = _data["filter"] ? ListBuilderFilter2.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["condition"] = this.condition;
        data["operator"] = this.operator;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyFilter {
    condition?: Conditions;
    operator?: string | undefined;
    filter?: ListBuilderFilter2 | undefined;
}

export enum Conditions {
    Equals = 1,
    DoesNotEqual = 2,
    Contains = 3,
    DoesNotContain = 4,
    GreaterThan = 5,
    LessThan = 6,
    OlderThan = 7,
    YoungerThan = 8,
    Before = 9,
    After = 10,
    On = 11,
    State = 12,
}

export class ListBuilderFilter2 implements IListBuilderFilter2 {
    /** Status */
    status?: RequestStatus[] | undefined;
    /** Summary */
    title?: string | undefined;
    /** CreatedOn */
    createdOn?: Date | undefined;
    /** Assignee */
    assignedTo?: string[] | undefined;
    /** Tags */
    tags?: string[] | undefined;
    /** Description */
    description?: string | undefined;
    /** TotalRevenue */
    totalRevenueRisk?: number | undefined;
    /** TotalDeviceCount */
    totalDeviceRisk?: number | undefined;
    /** Aging */
    aging?: Aging[] | undefined;
    /** DeviceModels */
    troubledProductCategory?: string[] | undefined;
    /** RequestedResolutionDate */
    requestedResolutionDate?: Date | undefined;
    addedOn?: Date | undefined;
    /** OpportunityId */
    msxOpportunity?: string | undefined;
    /** MsxStatus */
    msxStatus?: string | undefined;
    /** TpId */
    tpid?: string | undefined;
    /** CustomerName */
    endCustomer?: string | undefined;
    /** MsxTotalDeviceCount */
    msxDeviceCount?: number | undefined;
    /** MsxTotalRevenue */
    msxTotalRevenue?: number | undefined;
    /** CustomerCountry */
    customerCountry?: string[] | undefined;
    /** CustomerImpacts */
    customerNumber?: number | undefined;
    /** Relationship */
    relationship?: AssociationType[] | undefined;
    childrenNumber?: number | undefined;
    internalComment?: string | undefined;
    externalComment?: string | undefined;
    externalStatusTimestamp?: string | undefined;
    externalStatus?: string | undefined;
    /** Attachments */
    attachment?: number | undefined;
    /** IsDesignForSurfacePossible */
    dfsPossible?: string | undefined;
    /** BugInformations */
    bugType?: BugInformation[] | undefined;
    /** BugNumber */
    bugNumber?: string | undefined;
    /** CssCaseNumber */
    cssCaseNumber?: string | undefined;
    /** IsDcfRequest */
    dcfRequest?: boolean | undefined;
    /** ProofOfPurchaseAttached */
    proofOfPurchaseAttached?: boolean | undefined;
    /** Priority */
    priority?: Priority[] | undefined;
    /** SerialNumbersAttached */
    serialNumberAttached?: boolean | undefined;
    /** DcfApprovedValue */
    dcfValue?: number | undefined;
    /** PriorityNumber */
    cxpPriorityNumber?: number | undefined;
    /** CreatedBy */
    submittedBy?: string[] | undefined;

    constructor(data?: IListBuilderFilter2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.title = _data["title"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["assignedTo"])) {
                this.assignedTo = [] as any;
                for (let item of _data["assignedTo"])
                    this.assignedTo!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.description = _data["description"];
            this.totalRevenueRisk = _data["totalRevenueRisk"];
            this.totalDeviceRisk = _data["totalDeviceRisk"];
            if (Array.isArray(_data["aging"])) {
                this.aging = [] as any;
                for (let item of _data["aging"])
                    this.aging!.push(Aging.fromJS(item));
            }
            if (Array.isArray(_data["troubledProductCategory"])) {
                this.troubledProductCategory = [] as any;
                for (let item of _data["troubledProductCategory"])
                    this.troubledProductCategory!.push(item);
            }
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.addedOn = _data["addedOn"] ? new Date(_data["addedOn"].toString()) : <any>undefined;
            this.msxOpportunity = _data["msxOpportunity"];
            this.msxStatus = _data["msxStatus"];
            this.tpid = _data["tpid"];
            this.endCustomer = _data["endCustomer"];
            this.msxDeviceCount = _data["msxDeviceCount"];
            this.msxTotalRevenue = _data["msxTotalRevenue"];
            if (Array.isArray(_data["customerCountry"])) {
                this.customerCountry = [] as any;
                for (let item of _data["customerCountry"])
                    this.customerCountry!.push(item);
            }
            this.customerNumber = _data["customerNumber"];
            if (Array.isArray(_data["relationship"])) {
                this.relationship = [] as any;
                for (let item of _data["relationship"])
                    this.relationship!.push(item);
            }
            this.childrenNumber = _data["childrenNumber"];
            this.internalComment = _data["internalComment"];
            this.externalComment = _data["externalComment"];
            this.externalStatusTimestamp = _data["externalStatusTimestamp"];
            this.externalStatus = _data["externalStatus"];
            this.attachment = _data["attachment"];
            this.dfsPossible = _data["dfsPossible"];
            if (Array.isArray(_data["bugType"])) {
                this.bugType = [] as any;
                for (let item of _data["bugType"])
                    this.bugType!.push(item);
            }
            this.bugNumber = _data["bugNumber"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.dcfRequest = _data["dcfRequest"];
            this.proofOfPurchaseAttached = _data["proofOfPurchaseAttached"];
            if (Array.isArray(_data["priority"])) {
                this.priority = [] as any;
                for (let item of _data["priority"])
                    this.priority!.push(item);
            }
            this.serialNumberAttached = _data["serialNumberAttached"];
            this.dcfValue = _data["dcfValue"];
            this.cxpPriorityNumber = _data["cxpPriorityNumber"];
            if (Array.isArray(_data["submittedBy"])) {
                this.submittedBy = [] as any;
                for (let item of _data["submittedBy"])
                    this.submittedBy!.push(item);
            }
        }
    }

    static fromJS(data: any): ListBuilderFilter2 {
        data = typeof data === 'object' ? data : {};
        let result = new ListBuilderFilter2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["title"] = this.title;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.assignedTo)) {
            data["assignedTo"] = [];
            for (let item of this.assignedTo)
                data["assignedTo"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["description"] = this.description;
        data["totalRevenueRisk"] = this.totalRevenueRisk;
        data["totalDeviceRisk"] = this.totalDeviceRisk;
        if (Array.isArray(this.aging)) {
            data["aging"] = [];
            for (let item of this.aging)
                data["aging"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.troubledProductCategory)) {
            data["troubledProductCategory"] = [];
            for (let item of this.troubledProductCategory)
                data["troubledProductCategory"].push(item);
        }
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["addedOn"] = this.addedOn ? this.addedOn.toISOString() : <any>undefined;
        data["msxOpportunity"] = this.msxOpportunity;
        data["msxStatus"] = this.msxStatus;
        data["tpid"] = this.tpid;
        data["endCustomer"] = this.endCustomer;
        data["msxDeviceCount"] = this.msxDeviceCount;
        data["msxTotalRevenue"] = this.msxTotalRevenue;
        if (Array.isArray(this.customerCountry)) {
            data["customerCountry"] = [];
            for (let item of this.customerCountry)
                data["customerCountry"].push(item);
        }
        data["customerNumber"] = this.customerNumber;
        if (Array.isArray(this.relationship)) {
            data["relationship"] = [];
            for (let item of this.relationship)
                data["relationship"].push(item);
        }
        data["childrenNumber"] = this.childrenNumber;
        data["internalComment"] = this.internalComment;
        data["externalComment"] = this.externalComment;
        data["externalStatusTimestamp"] = this.externalStatusTimestamp;
        data["externalStatus"] = this.externalStatus;
        data["attachment"] = this.attachment;
        data["dfsPossible"] = this.dfsPossible;
        if (Array.isArray(this.bugType)) {
            data["bugType"] = [];
            for (let item of this.bugType)
                data["bugType"].push(item);
        }
        data["bugNumber"] = this.bugNumber;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["dcfRequest"] = this.dcfRequest;
        data["proofOfPurchaseAttached"] = this.proofOfPurchaseAttached;
        if (Array.isArray(this.priority)) {
            data["priority"] = [];
            for (let item of this.priority)
                data["priority"].push(item);
        }
        data["serialNumberAttached"] = this.serialNumberAttached;
        data["dcfValue"] = this.dcfValue;
        data["cxpPriorityNumber"] = this.cxpPriorityNumber;
        if (Array.isArray(this.submittedBy)) {
            data["submittedBy"] = [];
            for (let item of this.submittedBy)
                data["submittedBy"].push(item);
        }
        return data;
    }
}

export interface IListBuilderFilter2 {
    /** Status */
    status?: RequestStatus[] | undefined;
    /** Summary */
    title?: string | undefined;
    /** CreatedOn */
    createdOn?: Date | undefined;
    /** Assignee */
    assignedTo?: string[] | undefined;
    /** Tags */
    tags?: string[] | undefined;
    /** Description */
    description?: string | undefined;
    /** TotalRevenue */
    totalRevenueRisk?: number | undefined;
    /** TotalDeviceCount */
    totalDeviceRisk?: number | undefined;
    /** Aging */
    aging?: Aging[] | undefined;
    /** DeviceModels */
    troubledProductCategory?: string[] | undefined;
    /** RequestedResolutionDate */
    requestedResolutionDate?: Date | undefined;
    addedOn?: Date | undefined;
    /** OpportunityId */
    msxOpportunity?: string | undefined;
    /** MsxStatus */
    msxStatus?: string | undefined;
    /** TpId */
    tpid?: string | undefined;
    /** CustomerName */
    endCustomer?: string | undefined;
    /** MsxTotalDeviceCount */
    msxDeviceCount?: number | undefined;
    /** MsxTotalRevenue */
    msxTotalRevenue?: number | undefined;
    /** CustomerCountry */
    customerCountry?: string[] | undefined;
    /** CustomerImpacts */
    customerNumber?: number | undefined;
    /** Relationship */
    relationship?: AssociationType[] | undefined;
    childrenNumber?: number | undefined;
    internalComment?: string | undefined;
    externalComment?: string | undefined;
    externalStatusTimestamp?: string | undefined;
    externalStatus?: string | undefined;
    /** Attachments */
    attachment?: number | undefined;
    /** IsDesignForSurfacePossible */
    dfsPossible?: string | undefined;
    /** BugInformations */
    bugType?: BugInformation[] | undefined;
    /** BugNumber */
    bugNumber?: string | undefined;
    /** CssCaseNumber */
    cssCaseNumber?: string | undefined;
    /** IsDcfRequest */
    dcfRequest?: boolean | undefined;
    /** ProofOfPurchaseAttached */
    proofOfPurchaseAttached?: boolean | undefined;
    /** Priority */
    priority?: Priority[] | undefined;
    /** SerialNumbersAttached */
    serialNumberAttached?: boolean | undefined;
    /** DcfApprovedValue */
    dcfValue?: number | undefined;
    /** PriorityNumber */
    cxpPriorityNumber?: number | undefined;
    /** CreatedBy */
    submittedBy?: string[] | undefined;
}

export class Aging implements IAging {
    start?: Date;
    end?: Date;
    range?: string | undefined;

    constructor(data?: IAging) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.range = _data["range"];
        }
    }

    static fromJS(data: any): Aging {
        data = typeof data === 'object' ? data : {};
        let result = new Aging();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["range"] = this.range;
        return data;
    }
}

export interface IAging {
    start?: Date;
    end?: Date;
    range?: string | undefined;
}

export class UserSummaryCard implements IUserSummaryCard {
    bookmarkRequests?: number | undefined;
    watchRequests?: number | undefined;
    myRequests?: number | undefined;
    allRequests?: number;
    hiddenRequests?: number;
    unifiedTrackingIds?: string[] | undefined;

    constructor(data?: IUserSummaryCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookmarkRequests = _data["bookmarkRequests"];
            this.watchRequests = _data["watchRequests"];
            this.myRequests = _data["myRequests"];
            this.allRequests = _data["allRequests"];
            this.hiddenRequests = _data["hiddenRequests"];
            if (Array.isArray(_data["unifiedTrackingIds"])) {
                this.unifiedTrackingIds = [] as any;
                for (let item of _data["unifiedTrackingIds"])
                    this.unifiedTrackingIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserSummaryCard {
        data = typeof data === 'object' ? data : {};
        let result = new UserSummaryCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookmarkRequests"] = this.bookmarkRequests;
        data["watchRequests"] = this.watchRequests;
        data["myRequests"] = this.myRequests;
        data["allRequests"] = this.allRequests;
        data["hiddenRequests"] = this.hiddenRequests;
        if (Array.isArray(this.unifiedTrackingIds)) {
            data["unifiedTrackingIds"] = [];
            for (let item of this.unifiedTrackingIds)
                data["unifiedTrackingIds"].push(item);
        }
        return data;
    }
}

export interface IUserSummaryCard {
    bookmarkRequests?: number | undefined;
    watchRequests?: number | undefined;
    myRequests?: number | undefined;
    allRequests?: number;
    hiddenRequests?: number;
    unifiedTrackingIds?: string[] | undefined;
}

export class ListCount implements IListCount {
    queryId?: string;
    count?: number;

    constructor(data?: IListCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queryId = _data["queryId"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ListCount {
        data = typeof data === 'object' ? data : {};
        let result = new ListCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queryId"] = this.queryId;
        data["count"] = this.count;
        return data;
    }
}

export interface IListCount {
    queryId?: string;
    count?: number;
}

export class ListQueryDto implements IListQueryDto {
    id?: string;
    folderId?: string;
    starred?: boolean;
    queryName?: string | undefined;
    icon?: QueryIcon;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    queryFilters?: RequestListBuilderFilter | undefined;

    constructor(data?: IListQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.folderId = _data["folderId"];
            this.starred = _data["starred"];
            this.queryName = _data["queryName"];
            this.icon = _data["icon"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.queryFilters = _data["queryFilters"] ? RequestListBuilderFilter.fromJS(_data["queryFilters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["folderId"] = this.folderId;
        data["starred"] = this.starred;
        data["queryName"] = this.queryName;
        data["icon"] = this.icon;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["queryFilters"] = this.queryFilters ? this.queryFilters.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListQueryDto {
    id?: string;
    folderId?: string;
    starred?: boolean;
    queryName?: string | undefined;
    icon?: QueryIcon;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    queryFilters?: RequestListBuilderFilter | undefined;
}

export enum QueryIcon {
    PostIt = 0,
    Bug = 1,
    Settings = 2,
    Star = 3,
    Flag = 4,
    Warning = 5,
    Message = 6,
    Checkbox = 7,
    Notepad = 8,
    World = 9,
    Trophy = 10,
    Lightning = 11,
    Alarm = 12,
    Question = 13,
}

export class AssociateRequestDto implements IAssociateRequestDto {
    requestId?: string | undefined;
    associatedRequestId?: string | undefined;
    expectedCustomerFamilySubmissionId?: string | undefined;
    expectedCustomerFamilyGeneration?: number | undefined;

    constructor(data?: IAssociateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.associatedRequestId = _data["associatedRequestId"];
            this.expectedCustomerFamilySubmissionId = _data["expectedCustomerFamilySubmissionId"];
            this.expectedCustomerFamilyGeneration = _data["expectedCustomerFamilyGeneration"];
        }
    }

    static fromJS(data: any): AssociateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssociateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["associatedRequestId"] = this.associatedRequestId;
        data["expectedCustomerFamilySubmissionId"] = this.expectedCustomerFamilySubmissionId;
        data["expectedCustomerFamilyGeneration"] = this.expectedCustomerFamilyGeneration;
        return data;
    }
}

export interface IAssociateRequestDto {
    requestId?: string | undefined;
    associatedRequestId?: string | undefined;
    expectedCustomerFamilySubmissionId?: string | undefined;
    expectedCustomerFamilyGeneration?: number | undefined;
}

export class AssociateRequestsDto implements IAssociateRequestsDto {
    requestIds?: string[] | undefined;
    associatedRequestId?: string | undefined;
    customerFamilySubmissionId?: string | undefined;
    expectedCustomerFamilySubmissionId?: string | undefined;
    expectedCustomerFamilyGeneration?: number | undefined;

    constructor(data?: IAssociateRequestsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requestIds"])) {
                this.requestIds = [] as any;
                for (let item of _data["requestIds"])
                    this.requestIds!.push(item);
            }
            this.associatedRequestId = _data["associatedRequestId"];
            this.customerFamilySubmissionId = _data["customerFamilySubmissionId"];
            this.expectedCustomerFamilySubmissionId = _data["expectedCustomerFamilySubmissionId"];
            this.expectedCustomerFamilyGeneration = _data["expectedCustomerFamilyGeneration"];
        }
    }

    static fromJS(data: any): AssociateRequestsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssociateRequestsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requestIds)) {
            data["requestIds"] = [];
            for (let item of this.requestIds)
                data["requestIds"].push(item);
        }
        data["associatedRequestId"] = this.associatedRequestId;
        data["customerFamilySubmissionId"] = this.customerFamilySubmissionId;
        data["expectedCustomerFamilySubmissionId"] = this.expectedCustomerFamilySubmissionId;
        data["expectedCustomerFamilyGeneration"] = this.expectedCustomerFamilyGeneration;
        return data;
    }
}

export interface IAssociateRequestsDto {
    requestIds?: string[] | undefined;
    associatedRequestId?: string | undefined;
    customerFamilySubmissionId?: string | undefined;
    expectedCustomerFamilySubmissionId?: string | undefined;
    expectedCustomerFamilyGeneration?: number | undefined;
}

export class EditStatusDto implements IEditStatusDto {
    id?: string | undefined;
    status?: RequestStatus;
    customerFamilySubmissionId?: string | undefined;
    customerFamilyGeneration?: number | undefined;

    constructor(data?: IEditStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.customerFamilySubmissionId = _data["customerFamilySubmissionId"];
            this.customerFamilyGeneration = _data["customerFamilyGeneration"];
        }
    }

    static fromJS(data: any): EditStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["customerFamilySubmissionId"] = this.customerFamilySubmissionId;
        data["customerFamilyGeneration"] = this.customerFamilyGeneration;
        return data;
    }
}

export interface IEditStatusDto {
    id?: string | undefined;
    status?: RequestStatus;
    customerFamilySubmissionId?: string | undefined;
    customerFamilyGeneration?: number | undefined;
}

export class EditDevicesDto implements IEditDevicesDto {
    id?: string | undefined;
    devices?: DeviceModelDto[] | undefined;

    constructor(data?: IEditDevicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditDevicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditDevicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IEditDevicesDto {
    id?: string | undefined;
    devices?: DeviceModelDto[] | undefined;
}

export class PaginatedListOfStatusResponseDto implements IPaginatedListOfStatusResponseDto {
    items?: StatusResponseDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfStatusResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StatusResponseDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfStatusResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfStatusResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfStatusResponseDto {
    items?: StatusResponseDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class StatusResponseDto implements IStatusResponseDto {
    id?: string;
    statusText?: string | undefined;
    correlationId?: string | undefined;
    parentStatusId?: string;
    entityType?: EntityType;
    taggedUsers?: UserDto[] | undefined;
    isActive?: boolean | undefined;
    isInternal?: boolean | undefined;
    isExternal?: boolean | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;

    constructor(data?: IStatusResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusText = _data["statusText"];
            this.correlationId = _data["correlationId"];
            this.parentStatusId = _data["parentStatusId"];
            this.entityType = _data["entityType"];
            if (Array.isArray(_data["taggedUsers"])) {
                this.taggedUsers = [] as any;
                for (let item of _data["taggedUsers"])
                    this.taggedUsers!.push(UserDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.isInternal = _data["isInternal"];
            this.isExternal = _data["isExternal"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"] ? UserDto.fromJS(_data["modifiedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StatusResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusText"] = this.statusText;
        data["correlationId"] = this.correlationId;
        data["parentStatusId"] = this.parentStatusId;
        data["entityType"] = this.entityType;
        if (Array.isArray(this.taggedUsers)) {
            data["taggedUsers"] = [];
            for (let item of this.taggedUsers)
                data["taggedUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isActive"] = this.isActive;
        data["isInternal"] = this.isInternal;
        data["isExternal"] = this.isExternal;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStatusResponseDto {
    id?: string;
    statusText?: string | undefined;
    correlationId?: string | undefined;
    parentStatusId?: string;
    entityType?: EntityType;
    taggedUsers?: UserDto[] | undefined;
    isActive?: boolean | undefined;
    isInternal?: boolean | undefined;
    isExternal?: boolean | undefined;
    createdOn?: Date;
    createdBy?: UserDto | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: UserDto | undefined;
}

export class CreateStatusDto implements ICreateStatusDto {
    statusText?: string | undefined;
    correlationId?: string | undefined;
    parentStatusId?: string | undefined;
    entityType?: EntityType;
    id?: string | undefined;
    taggedUsers?: UserDto[] | undefined;
    isInternal?: boolean;
    isExternal?: boolean;

    constructor(data?: ICreateStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusText = _data["statusText"];
            this.correlationId = _data["correlationId"];
            this.parentStatusId = _data["parentStatusId"];
            this.entityType = _data["entityType"];
            this.id = _data["id"];
            if (Array.isArray(_data["taggedUsers"])) {
                this.taggedUsers = [] as any;
                for (let item of _data["taggedUsers"])
                    this.taggedUsers!.push(UserDto.fromJS(item));
            }
            this.isInternal = _data["isInternal"];
            this.isExternal = _data["isExternal"];
        }
    }

    static fromJS(data: any): CreateStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusText"] = this.statusText;
        data["correlationId"] = this.correlationId;
        data["parentStatusId"] = this.parentStatusId;
        data["entityType"] = this.entityType;
        data["id"] = this.id;
        if (Array.isArray(this.taggedUsers)) {
            data["taggedUsers"] = [];
            for (let item of this.taggedUsers)
                data["taggedUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isInternal"] = this.isInternal;
        data["isExternal"] = this.isExternal;
        return data;
    }
}

export interface ICreateStatusDto {
    statusText?: string | undefined;
    correlationId?: string | undefined;
    parentStatusId?: string | undefined;
    entityType?: EntityType;
    id?: string | undefined;
    taggedUsers?: UserDto[] | undefined;
    isInternal?: boolean;
    isExternal?: boolean;
}

export class CreateStatusesDto implements ICreateStatusesDto {
    parentStatus?: CreateStatusDto | undefined;
    childStatuses?: CreateStatusDto[] | undefined;

    constructor(data?: ICreateStatusesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentStatus = _data["parentStatus"] ? CreateStatusDto.fromJS(_data["parentStatus"]) : <any>undefined;
            if (Array.isArray(_data["childStatuses"])) {
                this.childStatuses = [] as any;
                for (let item of _data["childStatuses"])
                    this.childStatuses!.push(CreateStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStatusesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStatusesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentStatus"] = this.parentStatus ? this.parentStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.childStatuses)) {
            data["childStatuses"] = [];
            for (let item of this.childStatuses)
                data["childStatuses"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICreateStatusesDto {
    parentStatus?: CreateStatusDto | undefined;
    childStatuses?: CreateStatusDto[] | undefined;
}

export class GraphUserDto implements IGraphUserDto {
    displayName?: string | undefined;
    id?: string | undefined;
    mail?: string | undefined;
    mobilePhone?: string | undefined;
    businessPhones?: string[] | undefined;

    constructor(data?: IGraphUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.id = _data["id"];
            this.mail = _data["mail"];
            this.mobilePhone = _data["mobilePhone"];
            if (Array.isArray(_data["businessPhones"])) {
                this.businessPhones = [] as any;
                for (let item of _data["businessPhones"])
                    this.businessPhones!.push(item);
            }
        }
    }

    static fromJS(data: any): GraphUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GraphUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        data["mail"] = this.mail;
        data["mobilePhone"] = this.mobilePhone;
        if (Array.isArray(this.businessPhones)) {
            data["businessPhones"] = [];
            for (let item of this.businessPhones)
                data["businessPhones"].push(item);
        }
        return data;
    }
}

export interface IGraphUserDto {
    displayName?: string | undefined;
    id?: string | undefined;
    mail?: string | undefined;
    mobilePhone?: string | undefined;
    businessPhones?: string[] | undefined;
}

export class VisualFlowDto implements IVisualFlowDto {
    requestId?: string;
    title?: string | undefined;
    activities?: ActivityDto[] | undefined;

    constructor(data?: IVisualFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.title = _data["title"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(ActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VisualFlowDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisualFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["title"] = this.title;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IVisualFlowDto {
    requestId?: string;
    title?: string | undefined;
    activities?: ActivityDto[] | undefined;
}

export class BaseModel implements IBaseModel {
    id?: string;
    createdOn?: Date;
    createdBy?: User | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: User | undefined;

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? User.fromJS(_data["createdBy"]) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"] ? User.fromJS(_data["modifiedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaseModel {
    id?: string;
    createdOn?: Date;
    createdBy?: User | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: User | undefined;
}

export class ActivityDto extends BaseModel implements IActivityDto {
    title?: string | undefined;
    eventType?: string | undefined;
    activityType?: string | undefined;
    unifiedTrackingId?: string | undefined;
    icon?: VisualFlowIcon;
    status?: RequestStatus;
    attachmentCount?: number;
    attachments?: AttachmentDto[] | undefined;
    requestType?: RequestType;
    requestTeam?: RequestDomain;
    assignee?: UserDto | undefined;
    isActive?: boolean;
    commentCount?: number;
    comments?: CommentResponseDto[] | undefined;
    requestPerformedBy?: RequestActionSource | undefined;
    entityType?: EntityType;
    customerImpactEdit?: CustomerImpactEditEventDto | undefined;

    constructor(data?: IActivityDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.eventType = _data["eventType"];
            this.activityType = _data["activityType"];
            this.unifiedTrackingId = _data["unifiedTrackingId"];
            this.icon = _data["icon"];
            this.status = _data["status"];
            this.attachmentCount = _data["attachmentCount"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            this.requestType = _data["requestType"];
            this.requestTeam = _data["requestTeam"];
            this.assignee = _data["assignee"] ? UserDto.fromJS(_data["assignee"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.commentCount = _data["commentCount"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentResponseDto.fromJS(item));
            }
            this.requestPerformedBy = _data["requestPerformedBy"];
            this.entityType = _data["entityType"];
            this.customerImpactEdit = _data["customerImpactEdit"] ? CustomerImpactEditEventDto.fromJS(_data["customerImpactEdit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["eventType"] = this.eventType;
        data["activityType"] = this.activityType;
        data["unifiedTrackingId"] = this.unifiedTrackingId;
        data["icon"] = this.icon;
        data["status"] = this.status;
        data["attachmentCount"] = this.attachmentCount;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>undefined);
        }
        data["requestType"] = this.requestType;
        data["requestTeam"] = this.requestTeam;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["commentCount"] = this.commentCount;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : <any>undefined);
        }
        data["requestPerformedBy"] = this.requestPerformedBy;
        data["entityType"] = this.entityType;
        data["customerImpactEdit"] = this.customerImpactEdit ? this.customerImpactEdit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityDto extends IBaseModel {
    title?: string | undefined;
    eventType?: string | undefined;
    activityType?: string | undefined;
    unifiedTrackingId?: string | undefined;
    icon?: VisualFlowIcon;
    status?: RequestStatus;
    attachmentCount?: number;
    attachments?: AttachmentDto[] | undefined;
    requestType?: RequestType;
    requestTeam?: RequestDomain;
    assignee?: UserDto | undefined;
    isActive?: boolean;
    commentCount?: number;
    comments?: CommentResponseDto[] | undefined;
    requestPerformedBy?: RequestActionSource | undefined;
    entityType?: EntityType;
    customerImpactEdit?: CustomerImpactEditEventDto | undefined;
}

export enum VisualFlowIcon {
    RequestCreated = 1,
    RequestAssignedToTeam = 2,
    RequestAssignedToUser = 3,
    RequestReassigned = 4,
    RequestCustomerAdded = 5,
    RequestCustomerDeleted = 6,
    RequestResolved = 7,
    RequestClosed = 8,
    RequestInProgress = 9,
    RequestActive = 10,
    RequestUpdated = 11,
    RequestAttachmentAdded = 12,
    RequestAttachmentUpdated = 13,
    RequestAttachmentDeleted = 14,
    RequestCommentAdded = 15,
    RequestCommentDeleted = 16,
    RequestCommentUpdated = 17,
    RequestDeleted = 18,
    RequestAssociateAsParent = 19,
    RequestAssociateChildToParent = 20,
    RequestAssociateAsChild = 21,
    RequestUnassociate = 22,
    RequestPriorityChanged = 23,
}

export enum RequestActionSource {
    User = 0,
    System = 1,
}

export class CustomerImpactEditEventDto implements ICustomerImpactEditEventDto {
    id?: string;
    editedOn?: Date;
    editedBy?: UserDto | undefined;
    originalFingerprint?: string | undefined;
    updatedFingerprint?: string | undefined;
    oldDescription?: string | undefined;
    newDescription?: string | undefined;
    originalImpact?: CustomerImpactDto | undefined;
    updatedImpact?: CustomerImpactDto | undefined;
    isSameAsTicketChanged?: boolean | undefined;
    updatedIsSameAsTicket?: boolean | undefined;

    constructor(data?: ICustomerImpactEditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.editedOn = _data["editedOn"] ? new Date(_data["editedOn"].toString()) : <any>undefined;
            this.editedBy = _data["editedBy"] ? UserDto.fromJS(_data["editedBy"]) : <any>undefined;
            this.originalFingerprint = _data["originalFingerprint"];
            this.updatedFingerprint = _data["updatedFingerprint"];
            this.oldDescription = _data["oldDescription"];
            this.newDescription = _data["newDescription"];
            this.originalImpact = _data["originalImpact"] ? CustomerImpactDto.fromJS(_data["originalImpact"]) : <any>undefined;
            this.updatedImpact = _data["updatedImpact"] ? CustomerImpactDto.fromJS(_data["updatedImpact"]) : <any>undefined;
            this.isSameAsTicketChanged = _data["isSameAsTicketChanged"];
            this.updatedIsSameAsTicket = _data["updatedIsSameAsTicket"];
        }
    }

    static fromJS(data: any): CustomerImpactEditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImpactEditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["editedOn"] = this.editedOn ? this.editedOn.toISOString() : <any>undefined;
        data["editedBy"] = this.editedBy ? this.editedBy.toJSON() : <any>undefined;
        data["originalFingerprint"] = this.originalFingerprint;
        data["updatedFingerprint"] = this.updatedFingerprint;
        data["oldDescription"] = this.oldDescription;
        data["newDescription"] = this.newDescription;
        data["originalImpact"] = this.originalImpact ? this.originalImpact.toJSON() : <any>undefined;
        data["updatedImpact"] = this.updatedImpact ? this.updatedImpact.toJSON() : <any>undefined;
        data["isSameAsTicketChanged"] = this.isSameAsTicketChanged;
        data["updatedIsSameAsTicket"] = this.updatedIsSameAsTicket;
        return data;
    }
}

export interface ICustomerImpactEditEventDto {
    id?: string;
    editedOn?: Date;
    editedBy?: UserDto | undefined;
    originalFingerprint?: string | undefined;
    updatedFingerprint?: string | undefined;
    oldDescription?: string | undefined;
    newDescription?: string | undefined;
    originalImpact?: CustomerImpactDto | undefined;
    updatedImpact?: CustomerImpactDto | undefined;
    isSameAsTicketChanged?: boolean | undefined;
    updatedIsSameAsTicket?: boolean | undefined;
}

export class User implements IUser {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userRoles?: UserRole[] | undefined;
    userDomain?: RequestDomain | undefined;
    isContentCreator?: boolean;
    isEndUser?: boolean;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.userDomain = _data["userDomain"];
            this.isContentCreator = _data["isContentCreator"];
            this.isEndUser = _data["isEndUser"];
            this.isAdmin = _data["isAdmin"];
            this.isSuperAdmin = _data["isSuperAdmin"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : <any>undefined);
        }
        data["userDomain"] = this.userDomain;
        data["isContentCreator"] = this.isContentCreator;
        data["isEndUser"] = this.isEndUser;
        data["isAdmin"] = this.isAdmin;
        data["isSuperAdmin"] = this.isSuperAdmin;
        return data;
    }
}

export interface IUser {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userRoles?: UserRole[] | undefined;
    userDomain?: RequestDomain | undefined;
    isContentCreator?: boolean;
    isEndUser?: boolean;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class RequestApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isRequestApiException = true;

    static isRequestApiException(obj: any): obj is RequestApiException {
        return obj.isRequestApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new RequestApiException(message, status, response, headers, null);
}

// Adds Authorization header to requests made by the nswag generated clients

export class ApiError extends Error {
    status: number;
    statusText: string;
    detail: any;

    constructor(status: number, statusText: string, detail?: any) {
        super(`${status} ${statusText}`);
        this.name = 'ApiError';
        this.status = status;
        this.statusText = statusText;
        this.detail = detail;
    }

    static isApiError(obj: any): obj is ApiError {
        return obj instanceof ApiError;
    }
}